//#region imports
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone, OnDestroy, Output, ViewChild} from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, forkJoin, Observable, of, ReplaySubject, Subject, Subscription, throwError} from "rxjs";
import { BOCity } from "../../models/BOCity.model";
import { BOCountry } from "../../models/BOCountry.model";
import { BOIps } from "../../models/BOIps.model";
import { BOItem } from "../../models/BOItem.model";
import { BOPersonOcupation } from "../../models/BOPersonOcupation.model";
import { BOState } from "../../models/BOState.model";


import { BiologicalSexService } from "../../services/biologicalSex.service";
import { CityService } from "../../services/city.service";
import { ConsultationCauseService } from "../../services/consultationCause.service";
import { CountryService } from "../../services/country.service";
import { DiagnosticTypeService } from "../../services/diagnosticType.service";
import { DisabilityCategoryService } from "../../services/disabilityCategory.service";
import { EpsService } from "../../services/eps.service";
import { EthnicCommunityService } from "../../services/ethnicCommunity.service";
import { EthnicityService } from "../../services/ethnicity.service";
import { GenderIdentityService } from "../../services/genderIdentity.service";
import { IdTypeService } from "../../services/idType.service";
import { IpsService } from "../../services/ips.service";
import { PersonOcupationService } from "../../services/personOcupation.service";
import { ResidenceZoneService } from "../../services/residenceZone.service";
import { StateService } from "../../services/state.service";

import { StepperOrientation } from "@angular/cdk/stepper";
import { BreakpointObserver } from '@angular/cdk/layout';
import { catchError, finalize, map, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { BOClinicHistory } from "../../models/BOClinicHistory.model";
import { BOPerson } from "../../models/BOPerson.model";
import { PersonService } from "../../services/person.service";
import { ClinicHistoryService } from "../../services/clinicHistory.service";
import { ServiceGroupsService } from "../../services/serviceGroups.service";
import { HealthTecnologyModalityService } from "../../services/healthTecnologyModality.service";
import { PlaceOfAttentionService } from "../../services/placeOfAttention.service";
import { RouteOfEntryService } from "../../services/routeOfEntry.service";
import { TriageTypeService } from "../../services/triageType.service";
import { PatientInformationService } from "../../services/patientInformation.service";
import { BOPatientInformation } from "../../models/BOPatientInformation.model";
import { HealthTechnologyFinalityService } from "../../services/healthTechnologyFinality.service";
import { HealthTechnologyTimeUnitService } from "../../services/HealthTechnologyTimeUnit.service";
import { HealthTechnologyService } from "../../services/healthTechnology.service";
import { MatStepper } from "@angular/material/stepper";
import { BOClinicHistoryObservations } from "../../models/BOClinicHistoryObservations.model";
import { PatientConditionService } from "../../services/patientCondition.service";
import { DiseaseService } from "../../services/disease.service";
import { OrphanDiseaseService } from "../../services/orphanDisease.service";
import { BOEps } from "../../models/BOEps.model";
import { BOOrganDonor } from "../../models/BOOrganDonor.model";
import { BOAdvancedDirectiveDocument } from "../../models/BOAdvancedDirectiveDocument.model";
import { BOMedicDiagnostic } from "../../models/BOMedicDiagnostic.model";
import { BOHealthTechnologies } from "../../models/BOHealthTechnologies.model";
import { BOPrescriptionMedicationDose } from "../../models/BOPrescriptionMedicationDose.model";
import { BOHealthTechnologyTerm } from "../../models/BOHealthTechnologyTerm.model";
import { BOHealthTechnologyFrecuency } from "../../models/BOHealthTechnologyFrecuency.model";
import { BOHealthTechnologyMedicamentDoseTaken } from "../../models/BOHealthTechnologyMedicamentDoseTaken.model";
import { BOHealthTechnologyMedicamentDoseDelivered } from "../../models/BOHealthTechnologyMedicamentDoseDelivered.model";
import { BOHealthTecnologyDeliveredUnits } from "../../models/BOHealthTecnologyDeliveredUnits.model";
import { BOHealthTechnologiesResult } from "../../models/BOHealthTechnologiesResult.model";
import { BOPrincipalMedicDiagnostic } from "../../models/BOPrincipalMedicDiagnostic.model";
import { BORelatedMedicDiagnostic } from "../../models/BORelatedMedicDiagnostic.model";
import { BOComplicationMedicDiagnostic } from "../../models/BOComplicationMedicDiagnostic.model";
import { BODeathMedicDiagnostic } from "../../models/BODeathMedicDiagnostic.model";

import { CreateOrEditMedicalFormulaComponent } from "./createOrEditMedicalFormula.component";
import { BOMedicalFormula } from "../../models/BOMedicalFormula.model";

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { CompanyService } from "../../services/company.service";
import { BOCompany } from "../../models/BOCompany.model";
import { BOHeadQuarters } from "../../models/BOHeadQuarters.model";
import { HeadQuarterService } from "../../services/headQuarter.service";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DatePipe } from '@angular/common';

import { ServiceTypeService } from '../../services/service-type.service';
import { SellComponent } from './../sell/sell.component';
import { BOSell } from "../../models/BOSell.model";
import { BOSellDetail } from "../../models/BOSellDtail.model";
import { BOSubServiceType } from "../../models/BOSubServiceType.model";
import { SubServiceTypeService } from "../../services/subServiceType.service";
import { Utilities } from "../../common/utilities";
import { DialogConfirmService } from "../../services/dialog-confirm.service";
import { SellService } from "../../services/sell.service";
import { VoiceWriting2Component } from "../voice-writing2/voice-writing2.component";
import { MatExpansionPanel } from "@angular/material/expansion";
import { IcdProxy } from "../../services/icdProxy.service";
import { Icd10ToIcd11 } from '../../services/icd10ToIcd11.service';
import { BOIcd10ToIcd11 } from "../../models/BOIcd10ToIcd11.model";
import { ICei11Agrouped } from '../../interfaces/Igeneral.interface';
import { MatSelectChange, MatSelect } from "@angular/material/select";
import { RemissionComponent } from "../remission/remission.component";
import { MatOption } from "@angular/material/core";
import { BORelativeDisease } from "../../models/BORelativeDisease.model";
import { RelativeTypeService } from "../../services/relativeType.service";
import { RelativeDiseaseService } from "../../services/relativeDisease.service";
import { BOTranspRelativeDisease } from "../../models/auxiliars/BOTranspRelativeDisease.model";
import { MedicAllergyTypeService } from "../../services/medicAllergyType.service";
import { BOPatientAllergies } from "../../models/BOPatientAllergies.model";
import { BOTranspPatientAllergies } from "../../models/auxiliars/BOTranspPatientAllergies.model";
import { PatientAllergiesService } from '../../services/PatientAllergies.service';
import { DialogAlertService } from "../../services/dialogAlert.service";
import { MedicineCommonNameTypeService } from "../../services/medicineCommonNameType.service";
import { BOMedicineCommonNameType } from './../../models/BOMedicineCommonNameType.model';
import { BOPatientFarmacologicRecord } from '../../models/BOPatientFarmacologicRecord.model';
import { PatientFarmacologicRecordService } from "../../services/PatientFarmacologicRecords.service";
import { BOTranspFarmacologicRecords } from "../../models/auxiliars/BOTransPatientFarmacologicRecord.model";
import { InvoicesTaskComponent } from "../invoices-task/invoices-task.component";
import { ToothStateDetailService } from "../../services/toothStateDetail.service";
import { InamovibleCatalogService } from "../../services/InamovibleCatalogService";
import { BOInamovibleCatalog } from "../../models/BOInamovibleCatalog.model";
import { BOTransPatientRiskFactor } from "../../models/auxiliars/BOTranspPatientRiskFactor.model";
import { BOPatientRiskFactor } from "../../models/BOPatientRiskFactor.model";
import { BORiskFactorsType } from "../../models/BORiskFactorsType.model";
import { PatientRiskFactorService } from "../../services/patientRiskFactor.service";
import { BODiagnosticNovo } from "../../models/BODiagnosticNovo.model";
import { BOTranspDiagnosticNovo } from "../../models/auxiliars/BOTranspDiagnosticNovo.model";
import { DiagnosticNovoService } from "../../services/diagnosticNovo.service";
import { PatientClinicalData, PatientClinicalDataService } from "../../services/patientClinicalData.service";
import { BOChControl } from "../../models/BOChControl.model";
import { ChControlService } from "../../services/chControl.service";

//#endregion imports


@Component({
    selector: 'createOrEditClinicHistoryModal',
    templateUrl: './createOrEditClinicHistory.component.html',
    styleUrls: ['./createOrEditClinicHistory.component.css'],
    providers: [DatePipe]
})

export class CreateOrEditClinicHistoryComponent implements OnDestroy, AfterViewInit {
    @ViewChild('createOrEditModalObservation') public createOrEditModalObservation: ModalDirective;
    @ViewChild('createOrEditMedicalFormulaModal') public createOrEditMedicalFormulaModal: CreateOrEditMedicalFormulaComponent;
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @ViewChild('stepper', { static: true }) stepper: MatStepper;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('clinicHistoryContainer', { static: true }) clinicHistoryContainer: ElementRef;
    @ViewChild('sellModal') public sellModal: SellComponent;
    @ViewChild('voiceWriting2Component') voiceWriting2Component!: VoiceWriting2Component;
    @ViewChild('omsPanel') omsPanel: MatExpansionPanel;
    @ViewChild('remissionModal') public remissionModal: RemissionComponent;
    @ViewChild('invoicesTask') public invoicesTask: InvoicesTaskComponent;

    @ViewChild(MatSelect) matSelect!: MatSelect;
    @ViewChild('nextButton') nextButton: ElementRef;
//#region declarations
// Flags de control
  isSubmitting = false;  // Evita múltiples envíos
  errorMessage = '';
  successMessage = '';

  // Para debouncing del botón
    private clickSubject = new Subject<void>();


    busy: Subscription | undefined;
    submitted = false;
    emergencies: boolean = false;
    showOnlyObservations: boolean = false;
    showSaveIncapacityBtn:boolean=false;


    stepperIndex = 0;
    panelOpenState = false;



    tempObservationId = 0;
    tempObservation: BOClinicHistoryObservations = new BOClinicHistoryObservations();
    tempMedicalFormulaId = 0;

    cities                        : BOCity[] = [];
    biologicalSexList             : BOItem[] = [];
    consultationCauseList         : BOItem[] = [];
    diagnosticTypeList            : BOItem[] = [];
    disabilityCategoryList        : BOItem[] = [];
    epsList                       : BOEps [] = [];
    ethnicCommunityList           : BOItem[] = [];
    ethnicityList                 : BOItem[] = [];
    genderIdentityList            : BOItem[] = [];
    idTypeList                    : BOItem[] = [];
    ipsList                       : BOIps [] = [];
    residenceZoneList             : BOItem[] = [];
    healthTecnologyModalityList   : BOItem[] = [];
    placeOfAttentionList          : BOItem[] = [];
    routeOfEntryList              : BOItem[] = [];
    triageTypeList                : BOItem[] = [];
    healthTechnologyFinalityList  : BOItem[] = [];
    healthTechnologyList          : BOItem[] = [];
    healthTechnologyTimeUnitList  : BOItem[] = [];
    patientConditionList          : BOItem[] = [];
    diseaseList                   : BOItem[] = [];
    orphanDiseaseList             : BOItem[] = [];
    diseaseListRelated            : BOItem[] = [];
    diseaseListExit               : BOItem[] = [];
    diseaseListComplication       : BOItem[] = [];
    diseaseListDeath              : BOItem[] = [];
    orphanDiseaseRelatedList      : BOItem[] = [];
    orphanDiseaseExitList         : BOItem[] = [];
    orphanDiseaseComplicationList : BOItem[] = [];
    orphanDiseaseDeathList        : BOItem[] = [];
    medicAllergyTypeList          : BOItem[] = [];

    countries                     : BOCountry[] = [];
    states                        : BOState  [] = [];
    profesionals                  : BOPerson [] = [];
    headQuarterList               : BOHeadQuarters[] = [];
    personOcupationList           : BOPersonOcupation[] = [];
    company                       : BOCompany;


    clinicHistory                 : BOClinicHistory      = new BOClinicHistory();
    clinicHistoryControl          : BOClinicHistory      = new BOClinicHistory();
    patient                       : BOPerson             = new BOPerson();
    patientInformation            : BOPatientInformation = new BOPatientInformation();


    profesionalSelected           :number;
    areaSelected                  :number=1;

    categoryService               : string="";
    clinicHistorySended           :number=null;


    serviceGroupsList             : BOItem           [] = [];
    serviceTypeList               : BOItem           [] = [];
    subServiceTypeList            : BOSubServiceType [] = [];
    serviceGroupsListShort        : BOItem           [] = [];
    serviceTypeListShort          : BOItem           [] = [];
    profesionalsListShort         : BOPerson         [] = [];

   icd10ToIcd11List               : BOIcd10ToIcd11    [] = [];
   cei11AgroupedList              : ICei11Agrouped    [] = [];
   cei11AgroupedListOriginal      : ICei11Agrouped[] = [];
   ceiAgroupedListShort           : ICei11Agrouped[]=[]


   gotCei10List                   : BOIcd10ToIcd11    [] = [];
   gotCei10                       : BOIcd10ToIcd11= new BOIcd10ToIcd11();
   cei11AgroupedSelect            : ICei11Agrouped;

   medicineTypeList                : BOMedicineCommonNameType []=[];
   riskFactorList                  : BORiskFactorsType []=[];
   patientRiskFactorList           : BOPatientRiskFactor[]=[];
   patientDiagnosticAllList        : BODiagnosticNovo[]=[];
   patientDiagnosticPrincipalList  : BODiagnosticNovo[]=[];
   patientDiagnosticRelatedList    : BODiagnosticNovo[]=[];
  relativeDiseases                 : BORelativeDisease[]=[];
  patientAllergiesList             : BOPatientAllergies[]=[];
  patientFarmacologicRecordsList   : BOPatientFarmacologicRecord[]=[];
  chControlList                    : BOChControl[]=[];
  chClinicHistoryObservationsList  : BOClinicHistoryObservations[]=[];



   private isModalMode: boolean = true; // Bandera para controlar el modo
   private cei11FilterSubscription: Subscription | null = null;


    filteredCountries                 : ReplaySubject<BOCountry[]> = new ReplaySubject<BOCountry[]>(1);
    filteredDiseases                  : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredDiseasesRelated           : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredDiseasesExit              : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredDiseasesComplication      : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredDiseasesDeath             : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredOrphanDiseases            : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredOrphanDiseasesRelated     : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredOrphanDiseasesExit        : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredOrphanDiseasesComplication: ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);
    filteredOrphanDiseasesDeath       : ReplaySubject<BOItem[]> = new ReplaySubject<BOItem[]>(1);

    filteredIcd10ToIcd11              : ReplaySubject<BOIcd10ToIcd11[]> = new ReplaySubject<BOIcd10ToIcd11[]>(1);
    filteredCei11Agrouped             : ReplaySubject<ICei11Agrouped[]> = new ReplaySubject<ICei11Agrouped[]>(1);


    filteredOcupation                 : ReplaySubject<BOPersonOcupation[]> = new ReplaySubject<BOPersonOcupation[]>(1);
    filteredEps                       : ReplaySubject<BOEps[]> = new ReplaySubject<BOEps[]>(1);
    countryFilterCtrl                 : FormControl = new FormControl();
    diseaseFilterCtrl                 : FormControl = new FormControl();


    filteredMedicineType              : ReplaySubject<BOMedicineCommonNameType[]> =new ReplaySubject<BOMedicineCommonNameType[]>(1);
    MedicineTypeFilterCtrl            : FormControl = new FormControl();


    diseaseRelatedFilterCtrl          : FormControl = new FormControl();
    diseaseExitFilterCtrl             : FormControl = new FormControl();
    diseaseComplicationFilterCtrl     : FormControl = new FormControl();
    diseaseDeathFilterCtrl            : FormControl = new FormControl();
    orphanDiseaseFilterCtrl           : FormControl = new FormControl();
    orphanDiseaseRelatedFilterCtrl    : FormControl = new FormControl();
    orphanDiseaseExitFilterCtrl       : FormControl = new FormControl();
    orphanDiseaseComplicationFilterCtrl: FormControl = new FormControl();
    orphanDiseaseDeathFilterCtrl      : FormControl = new FormControl();
    ocupationFilterCtrl               : FormControl = new FormControl();
    epsFilterCtrl                     : FormControl = new FormControl();
    icd10ToIcd11FilterCtrl            : FormControl = new FormControl();
    cei11AgroupedFilterCtrl           : FormControl = new FormControl();


    searchingDisease                  : boolean = false;

    searchingOrphanDisease            : boolean = false;
    showOtherProcedureControl         : boolean = false;

    searchingIcd10ToIcd11             : boolean = false;
    searchingCei11Agrouped            : boolean = false;
    searchingMedicineType             : boolean = false;


    stepperOrientation: Observable<StepperOrientation>;
    protected _onDestroy = new Subject<void>();

    isSearchPatient: boolean = false;
    isControl:boolean=false;
    clinicHistoryAsignedToSell=0;
    isFormModalOpen = false; // Controla el sombreado
    isNav=true; //controla si se deshabilitan botones de navegación

    isSaving:boolean=false;
    isLoading:boolean=false;

    isChDiagnosticPanelOpen:boolean=false;

    relativeTypeList:BOItem[]=[];

    code11= "";
    code11Title =""
    code10 ="";
    code10Title ="";
    selectedGroup:ICei11Agrouped[]=[]


//#endregion
  showScrollDownArrow: boolean = false;


//#region OMS
omsSelectedDiagnosis:string="";
omsSelectedDiagnosisCode:string="";

//capturar datos de Cei11 y Cei10
selectedGroupCodeIcd11  : string | null = null;
selectedTitleIcd11      : string | null = null;
selectedCodeIcd10       : string | null = null;
selectedTitleIcd10      : string | null = null;
BOClinicHistoryInput    : any;




//btnSaveRelativeDisease  :boolean=false;
btnsavePatientRiskFactor:boolean=false;
btnSaveFarmacologicRecords: boolean=false;
btnSavePatientAllergies: boolean=false;
btnSaveDiagnosticRelated: boolean=false;


showDiagnosticPrincipal_ppal_diseaseType: boolean=true;

showDiagnosticRelated_ppal_diseaseType= new BehaviorSubject<boolean>(true);
sdrpd = this.showDiagnosticRelated_ppal_diseaseType;


showDiagnosticPrincipal_ppal: boolean=false;
showDiagnosticPrincipal_orpha: boolean=false;
showDiagnosticPrincipal_ppal_component: boolean=false;
showDiagnosticPrincipal_orpha_component: boolean=false;

showDiagnosticRelated_ppal: boolean=false;
showDiagnosticRelated_orpha: boolean=false;
showDiagnosticRelated_ppal_component: boolean=false;
showDiagnosticRelated_orpha_component: boolean=false;


onSelectCei11ItemPrincipalDiagnostic(event: MatSelectChange): void {
    const selected = event.value;

    if (!selected || !selected.group || !selected.item) {
        console.warn("   Selección inválida");
        return;
    }

    // Asignar valores
    this.selectedGroupCodeIcd11 = selected.group.key;
    this.selectedTitleIcd11 = selected.group.listCei10ToCei11[0]?.titleIcd11Spanish || '';
    this.selectedCodeIcd10 = selected.item.codeIcd10;
    this.selectedTitleIcd10 = selected.item.titleIcd10Spanish;


    // Actualizar lista corta
    this.ceiAgroupedListShort = [selected.group];

    // Cambiar a modo modal
    this.isModalMode = true;

    // Emitir selección al ReplaySubject
    setTimeout(() => {
        this.filteredCei11Agrouped.next(this.ceiAgroupedListShort.slice());
        this._cdr.detectChanges();
    }, 100);
}


  onSelectCei11ItemRelative(event: MatSelectChange): void
  {
      this.code11= "";
      this.code11Title =""
      this.code10 ="";
      this.code10Title ="";
      this.selectedGroup=[];


      const selected = event.value;

      if (!selected || !selected.group || !selected.item) {
          console.warn("   Selección inválida");
          return;
      }

      this.code11= selected.group.key;
      this.code11Title = selected.group.listCei10ToCei11[0]?.titleIcd11Spanish || '';
      this.code10 = selected.item.codeIcd10;
      this.code10Title = selected.item.titleIcd10Spanish;
      this.selectedGroup=[selected.group];

  }

  onDiagnosisChange(newDiagnostic: string): void {
    this.omsSelectedDiagnosis = newDiagnostic;
    this._cdr.detectChanges();
  }

  // Método para actualizar el código cuando el hijo emita el cambio
  onCodeChange(newCode: string): void {
    this.omsSelectedDiagnosisCode = newCode;
        this._cdr.detectChanges();
  }

// Método que se ejecutará cuando el hijo emita el evento de guardar
  onDiagnosticSaved() {
     if (this.omsPanel) {
      this.omsPanel.close();
    } else {
      console.warn('⚠️ No se encontró la referencia al panel OmsPanel');
    }
  }

  testGetIcd10(){
    this._icdProxyService.getIcd10('5A11').subscribe(data=>{
    })
  }

//#endregion OMS

//#region types

diseaseTypeList=[
    {
      id:1,
      code:'01',
      name:'Enfermedad Común'
    },
    {
      id:2,
      code:'02',
      name:'Enfermedad Huérfana'
    }
];

diagnosticCategoryList=[
    {
      id:1,
      code:'01',
      name:'Diagn.Principal'
    },
    {
      id:2,
      code:'02',
      name:'Diagn.Relacionado'
    }
];

patientConditionAndDestinationList=[
    {
      id:1,
      code:'01',
      name:'PACIENTE CON DESTINO A SU DOMICILIO'
    },
    {
      id:2,
      code:'02',
      name:'PACIENTE MUERTO'
    },

    {
      id:3,
      code:'03',
      name:'PACIENTE DERIVADO A OTRO SERVICIO'
    },
    {
      id:4,
      code:'04',
      name:'REFERIDO A OTRA INSTITUCION'
    },
    {
      id:5,
      code:'05',
      name:'CONTRAREFERIDO A OTRA INSTITUCION'
    },
    {
      id:6,
      code:'06',
      name:'DERIVADO O REFERIDO A HOSPITALIZACION DOMICILIRIA'
    },
    {
      id:7,
      code:'07',
      name:'DERIVADO A SERVICIO SOCIAL'
    },
    {
      id:8,
      code:'08',
      name:'PACIENTE CONTINUA EN EL SERVICIO (CORTE FACTURACION)'
    },

] as BOItem[];

//#endregion types


//#region create formsGroups and controls
    firstFormGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required], //Primer Nomber
        secondCtrl: '', //Segundo Nombre
        threeCtrl: ['', Validators.required], //Primer Apellido
        fourCtrl: '',//segundo apellido
        fifthCtrl: ['', Validators.required], //Tipo documento CC,TI
        sixCtrl: ['', Validators.required], //Número documento
        sevenCtrl: ['centromedicoservi-vital@gmail.com', Validators.required], //correo electronico
        eightCtrl: ['', Validators.required], //telefono celular del paciente
        nineCtrl: ['Siloe', Validators.required], //direccion
        tenCtrl: ['', Validators.required], //Telefono celular contacto
        elevenCtrl: '', //fecha de nacimiento
        twelveCtrl: ''//contacto emergencia
    });

    secondFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: null,
        sixCtrl: null,
        sevenCtrl: ['999999', Validators.required], //EPS
        eightCtrl: null,
        nineCtrl: ['456', Validators.required], //oCUPACION
        tenCtrl: null,
        elevenCtrl: '',
        twelveCtrl: '',
        thirteen: null,
        fourtheen: null,
        fiftheen: null,
        sixteen: null
    });
//Datos de ingreso
    thirdFormGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required], //Fecha de la Atencion
        secondCtrl: ['', Validators.required],//Prestador de Servicios
        threeCtrl: [null, Validators.required], //Grupo de Servicios
        fourCtrl: ['', Validators.required],//Modalidad de la Tecnologia de Salud
        fifthCtrl: ['', Validators.required], //Lugar de Atención
        sixCtrl: ['', Validators.required], //Ruta de Entrada
        sevenCtrl: ['', Validators.required], //Causa de Atención
        eightCtrl: null,
        nineCtrl: null,
        thirteenCtrl: [null, Validators.required], //Tipo de servicio
        fourteenCtrl: [0, Validators.required],//Precio
        fifteenCtrl:  [null, Validators.required],//Cómo nos conoció?-Observaciones
    });

    fourFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: "0",
        sixCtrl: null,
        sevenCtrl: null,
        eightCtrl: "0",
        nineCtrl: null,
        tenCtrl: "0",
        elevenCtrl: null,
        twelveCtrl: "0",
        thirteenCtrl: null,
        fourteenCtrl: null,
        fiftheenCtrl: "0",
        sixteenCtrl: null,
        seventeenCtrl: "0",
        eighteenCtrl: null,
        nineteenCtrl: null,
        twentyCtrl: null
    });

    fifthFormGroup = this._formBuilder.group({
        firstCtrl: null,
        secondCtrl: null,
        threeCtrl: null,
        fourCtrl: null,
        fifthCtrl: null,
        sixCtrl: null,
        sevenCtrl: null,
        eightCtrl: null,
        nineCtrl: null,
        tenCtrl: null,
        elevenCtrl: null,
        twelveCtrl: null,
        thirteenCtrl: '00',
        fourteenCtrl: "0",
        fiftheenCtrl: "0",
        sixteenCtrl: null,
        seventeenCtrl: null
    });

    sixFormGroup = this._formBuilder.group({
        firstCtrl: null,            //Antecedentes Patologicos
        secondCtrl: null,           //Motivo de Consulta
        threeCtrl: null,            //Anamnesis
        fourCtrl: null,             //Presion arterial
        fifthCtrl: null,            //Temperatura
        sixCtrl: null,              //pulso
        sevenCtrl: null,            //peso
        eightCtrl: null,            //talla
        nineCtrl: null,             //Respiracion
        tenCtrl: null,              //Cabeza
        elevenCtrl: null,           //
        twelveCtrl: null,
        thirteenCtrl: null,
        fourteenCtrl: null,
        fiftheenCtrl: null,
        sixteenCtrl: null,
        seventeenCtrl: null,
        eighteenCtrl: null,
        nineteenCtrl: null,
        twentyCtrl: null,           //Plan de Tratamiento
        twentyOneCtrl: null,        //Diangóstico Principal -CEI10-eliminado
        twentyTwoCtrl: null,        //eliminado
        twentyThreeCtrl: null,        //eliminado
        twentyFourCtrl: null,       //eliminado

        diagnosticType:null,        //eliminado
    });

    destinationPatientFormGroup= this._formBuilder.group({
        consultationDateEnd:[null, Validators.required],
        patientConditionAndDestination:['01', Validators.required],
        patientDestinationOrganization:null,
        patientDestinationOrganizationName:null,

    })

    relativeDiseaseFormGroup = this._formBuilder.group({
        cei11Diagnostic: [null, Validators.required],
        relativeType:[null, Validators.required],
      });

    patientAllergiesFormGroup = this._formBuilder.group({
        // allergyType: null,
        // allergen:null
        allergyType: [null, Validators.required],
        allergen: [null, Validators.required]
      });

    medicinesFormGroup = this._formBuilder.group({
        code: [null, Validators.required],
        name:[null],
        enabled:[null],
      });
    detailPatientRiskFactorFormGroup = this._formBuilder.group({
        riskFactorType: [null, Validators.required],
        riskFactorDetail: [null]
      });

    patientDiagnosticPrincipalFormGroup= this._formBuilder.group({
        //diseaseType: [null, Validators.required],
        diseaseCode: [null, Validators.required],
        diseaseName: [null, Validators.required],

        diagnosticType: ['01',Validators.required],
        details: [null],
    })

    patientDiagnosticRelatedFormGroup= this._formBuilder.group({
        diseaseCode: [null, Validators.required],
        diseaseName: [null, Validators.required],
        diagnosticType: ['01',Validators.required],
        details: [null],
    })


    chControlFatherFormGroup= this._formBuilder.group({
        controlDate: ['',Validators.required],
        professionalId: [null, Validators.required],
        details: [null],
    })



    //#endregion


    constructor(public toastr                     : ToastrService,
                private _datePipe                 : DatePipe,
                private _cdr                      : ChangeDetectorRef,
                private _ngZone                   : NgZone,
        private _biologicalSexService             : BiologicalSexService,
        private _cityService                      : CityService,
        private _consultationCauseService         : ConsultationCauseService,
        private _countryService                   : CountryService,
        private _diagnosticTypeService            : DiagnosticTypeService,
        private _disabilityCategoryService        : DisabilityCategoryService,
        private _epsService                       : EpsService,
        private _ethnicCommunityService           : EthnicCommunityService,
        private _ethnicityService                 : EthnicityService,
        private _genderIdentityService            : GenderIdentityService,
        private _idTypeService                    : IdTypeService,
        private _ipsService                       : IpsService,
        private _personOcupationService           : PersonOcupationService,
        private _residenceZoneService             : ResidenceZoneService,
        private _stateService                     : StateService,
        private _formBuilder                      : FormBuilder, breakpointObserver: BreakpointObserver,
        private _personService                    : PersonService,
        private _clinicHistoryService            : ClinicHistoryService,
        private _serviceGroupsService            : ServiceGroupsService,
        private _healthTecnologyModalityService  : HealthTecnologyModalityService,
        private _placeOfAttentionService         : PlaceOfAttentionService,
        private _routeOfEntryService             : RouteOfEntryService,
        private _triageTypeService               : TriageTypeService,
        private _patientInformationService       : PatientInformationService,
        private _healthTechnologyFinalityService : HealthTechnologyFinalityService,
        private _healthTechnologyTimeUnitService : HealthTechnologyTimeUnitService,
        private _healthTechnologyService         : HealthTechnologyService,
        private _patientConditionService         : PatientConditionService,
        private _diseaseService                  : DiseaseService,
        private _orphanDiseaseService            : OrphanDiseaseService,
        private _companyService                  : CompanyService,
        private _headQuarterService              : HeadQuarterService,
        private datePipe                         : DatePipe,
        private _serviceTypeService              : ServiceTypeService,
        private _subServiceTypeService           : SubServiceTypeService,
        private _dialogConfirm                   : DialogConfirmService,
        private _dialogAlertService              : DialogAlertService,

        private _sellService                     : SellService,
        private _icdProxyService                 : IcdProxy,
        private _icd10ToIcd11Service             : Icd10ToIcd11,
        private _relativeTypeService             : RelativeTypeService,
        private _relativeDiseaseService          : RelativeDiseaseService,
        private _medicAllergyTypeService         : MedicAllergyTypeService,
        private _patientAllergiesService         : PatientAllergiesService,
        private _medicineTypeService             : MedicineCommonNameTypeService,
        private _patientFarmacologicRecordService: PatientFarmacologicRecordService,
        private _inamovibleCatalogService        : InamovibleCatalogService,
        private _patientRiskFactorService        : PatientRiskFactorService,
        private _patientDiagnosticService        : DiagnosticNovoService,
        private _patientClinicalDataService      : PatientClinicalDataService,
        private _chControlService                : ChControlService,
        ) {

        this.stepperOrientation = breakpointObserver.observe('(min-width: 800px)')
            .pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
    }


    ngAfterViewInit()
      {
        // Escuchar cambios en el stepper para hacer scroll automático
        if (this.stepper)
        {
            this.stepper.selectionChange.subscribe(() => {
                this.scrollToTop();
                // Verificar si mostrar la flecha después del scroll
                setTimeout(() => {
                    this.checkScrollPosition();
                }, 600);
            });
        }

        // Agregar listener para detectar scroll y mostrar/ocultar flecha
        if (this.clinicHistoryContainer?.nativeElement)
        {
            this.clinicHistoryContainer.nativeElement.addEventListener('scroll', () => {
                this.checkScrollPosition();
            });
        }

        if (this.voiceWriting2Component)
        {
          this.voiceWriting2Component.setFormGroup(this.sixFormGroup);
        }

    }
//#region open modal
    openModal(clinicHistoryId: number,showOnlyObservations: boolean, categoryService: string, isnav:boolean ): void
    {
      //isnav?this.isNav=true:this.isNav=false;
      this.isNav=isnav;

        this.showOnlyObservations = showOnlyObservations;
        this.showSaveIncapacityBtn=false;

        this.submitted = true;
        this.modal.config = { backdrop: "static", keyboard: false };
        this.modal.show();

        this.isSaving=false;

        this.serviceGroupsListShort=[];
        this.serviceTypeListShort  =[];
        this.profesionalsListShort =[];

        this.relativeDiseases              =[];
        this.patientFarmacologicRecordsList=[];
        this.patientAllergiesList          =[];
        this.patientDiagnosticPrincipalList=[];
        this.patientDiagnosticRelatedList  =[];
        this.patientRiskFactorList         =[];
        this.chControlList                 =[];

//Ric
        this.categoryService=categoryService;
        this.clinicHistorySended=clinicHistoryId;
        this.firstFormGroup.patchValue({
           fifthCtrl: "CC"
        });

      //  this.btnSaveRelativeDisease=false;
        this.btnsavePatientRiskFactor=false;
        this.btnSaveFarmacologicRecords=false;
        this.btnSavePatientAllergies=false;

        this.btnSaveDiagnosticRelated=false;


//end Ric

this.loadFormData(clinicHistoryId);

}//end openModal


//#region NEW DATA NEW FORJOIN
private loadFormData(clinicHistoryId: number): void
{
  forkJoin({
    fixed : this._inamovibleCatalogService.getAll(),
    city  : this._cityService.getCitiesbyState("NN"),
    ocupation: this._personOcupationService.getAll(),
  }).pipe(
    tap(({ fixed, city, ocupation }) => {
      this.cities           = city;
      this.assignFixedCatalog(fixed);
      this.personOcupationList = ocupation;

      this.assignFilteredCatalog();
      this.initalizeClinicHistoryData(clinicHistoryId);

     // this.personOcupationList = ocupation;
    }),
    switchMap(() => forkJoin({
      resultDisease      : this._diseaseService.getAll(".n"),
      resultOrphanDisease: this._orphanDiseaseService.getAll(".n"),
      resultIcd10ToIcd11 : this._icd10ToIcd11Service.getAll(".n"),
      resultMedicineType : this._medicineTypeService.getAll(".n"),
      resultCei11        : this._icd10ToIcd11Service.getCei11AgroupedByIcd11(".n"),
    })),
    catchError(err => {
      //this.errorLoading = true;
      return throwError(() => err);
    })
  ).subscribe(({ resultDisease,
                 resultOrphanDisease,
                 resultIcd10ToIcd11,
                 resultMedicineType,
                 resultCei11 }) => {
    this.diseaseList       = resultDisease;
    this.orphanDiseaseList = resultOrphanDisease;
    this.icd10ToIcd11List  = resultIcd10ToIcd11;
    this.medicineTypeList  = resultMedicineType;
    // this.cei11List         = resultCei11;
    this.icd10ToIcd11List             = resultIcd10ToIcd11;

    this.cei11AgroupedList               = resultCei11;
    this.cei11AgroupedListOriginal       = resultCei11;

  });
}

private assignFixedCatalog(data: BOInamovibleCatalog): void {
  this.biologicalSexList           = data.biologicalSex;
  this.consultationCauseList       = data.consultationCause;
  this.diagnosticTypeList          = data.diagnosticType;
  this.disabilityCategoryList      = data.disabilityCategory;
  this.epsList                     = data.eps;
  this.ethnicCommunityList         = data.ethnicCommunity;
  this.ethnicityList               = data.ethnicity;
  this.genderIdentityList          = data.genderIdentity;
  this.idTypeList                  = data.idType;
  this.ipsList                     = data.ips;
  this.residenceZoneList           = data.residenceZone;
  this.healthTecnologyModalityList = data.healthTecnologyModality;
  this.serviceGroupsList           = data.serviceGroups;
  this.placeOfAttentionList        = data.placeOfAttention;
  this.routeOfEntryList            = data.routeOfEntry;
  this.triageTypeList              = data.triageType;
  this.healthTechnologyFinalityList= data.healthTechnologyFinality;
  this.healthTechnologyTimeUnitList= data.healthTechnologyTimeUnit;
  this.healthTechnologyList        = data.healthTechnology;
  this.patientConditionList        = data.patientCondition;
  this.company                     = data.company[0];
  this.headQuarterList             = data.headquarter;
  this.profesionals                = data.profesionals;
  this.serviceTypeList             = data.serviceType;
  this.subServiceTypeList          = data.subServiceType;
  this.relativeTypeList            = data.relativeType;
  this.medicAllergyTypeList        = data.medicAllergyType;
  this.countries                   = data.countries;
  this.riskFactorList              = data.riskFactorsType

}

assignFilteredCatalog(){
              this.filteredCountries.next(this.countries.slice());
        // listen for search field value changes
          this.countryFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterCountries();
            });
    ///NEW NEV


        this.filteredEps.next(this.epsList.slice());
          this.epsFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterEps();
            });
    this.filteredEps.pipe(take(1)).subscribe(() => {
    // console.log('Lista EPS:', this.epsList.map(o => o.code));
    // console.log('¿Existe EPS 999999?', this.epsList.some(o => o.code === '999999'));

    setTimeout(() => {
        this.secondFormGroup.get('sevenCtrl')?.setValue('999999');
        this._cdr.detectChanges();
    }, 0);

        //this.secondFormGroup.get('sevenCtrl')?.setValue('999999');
    });
console.log("Antes de FilteredOcupation, this.personOcupationList es:", this.personOcupationList);
    //    this.filteredOcupation.next(this.personOcupationList.slice());
    this.filteredOcupation.next(
    (this.personOcupationList || []).slice()
);
            this.ocupationFilterCtrl.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterOcupation();
                });
    // 3. [NUEVO] Establecer valor predeterminado DESPUÉS de que haya opciones
    console.log('LISTA OCUPA ORIGINAL ES:', this.personOcupationList);
    this.filteredOcupation.pipe(take(1)).subscribe(() => {
    console.log('Lista ocupaciones:', this.personOcupationList.map(o => o.code));
    console.log('¿Existe OCUPACION 5169?', this.personOcupationList.some(o => o.code === '5169'));
    console.log("Ocupa 5169 es:", this.personOcupationList.find(x=>x.code==='5169').description);
    setTimeout(() => {
        this.secondFormGroup.get('nineCtrl')?.setValue('5169');
        this._cdr.detectChanges();
    }, 0);


    });

        this.orphanDiseaseFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOrphanDiseases();
            });
        this.orphanDiseaseRelatedFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOrphanDiseasesRelated();
            });
        this.orphanDiseaseExitFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOrphanDiseasesExit();
            });
        this.orphanDiseaseComplicationFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOrphanDiseasesComplication();
            });
        this.orphanDiseaseDeathFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterOrphanDiseasesDeath();
            });

        this.filteredDiseases.next(this.diseaseList.slice());

        this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());

        this.filteredDiseasesExit.next(this.diseaseListExit.slice());

        this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
        this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());

        this.filteredMedicineType.next(this.medicineTypeList.slice());

        this.diseaseExitFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterDiseasesExit();
            });

        // listen for search field value changes
        this.MedicineTypeFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterMedicineType();
            });
        this.diseaseRelatedFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterDiseasesRelated();
            });
        this.diseaseExitFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterDiseasesExit();
            });
        this.diseaseComplicationFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterDiseasesComplication();
            });
        this.diseaseDeathFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterDiseasesDeath();
            });

      this.icd10ToIcd11FilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterIcd10ToIcd11();
            });

      this.cei11AgroupedFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCei11AgroupedUnified();
      });

      this._stateService.getStatesbyCountry(this.countries[0].id).subscribe(data => {
            this.states = data;
      });
}

private destroy$ = new Subject<void>();

initalizeClinicHistoryData(clinicHistoryId: number): void {
  this.profesionalsListShort = Utilities.getProfessionalssByAreaId(1, this.profesionals);
  this.serviceGroupsListShort = Utilities.getGroupsByAreaId(1, this.serviceGroupsList);

 if (clinicHistoryId <= 0)
 {
    this.clinicHistory.id = 0;
    this.patient.id = 0;
    this.isModalMode = false;
    return; // ✅ Early return evita el else anidado
  }

  this._clinicHistoryService.getClinicHistory(clinicHistoryId).pipe(
    takeUntil(this.destroy$),

    // ✅ switchMap encadena la clínica con las llamadas paralelas
    switchMap(clinicHistory => {
      this.gotCei10 = null;
      this.clinicHistory = clinicHistory;
      this.clinicHistoryControl = JSON.parse(JSON.stringify(clinicHistory));
      this.patient = clinicHistory.patient;
      this.profesionalSelected = this.profesionals.find(x => x.id === clinicHistory.profesional?.id)?.id;
      this.areaSelected = clinicHistory.area;
      this.serviceGroupsListShort = Utilities.getGroupsByAreaId(this.areaSelected, this.serviceGroupsList);
      this.serviceTypeListShort = Utilities.getServicesByGroupId(clinicHistory.serviceGroups, this.serviceTypeList);

      // ✅ forkJoin lanza TODAS las llamadas en paralelo simultáneamente
      return forkJoin({
        sell: this._sellService.getSellByClinicHistoryId(clinicHistory.id),
        patientInfo: clinicHistory.patient.patientInformationId != null
          ? this._patientInformationService.getPatientInformation(clinicHistory.patient.patientInformationId)
          : of(null),
        // ✅ Reutiliza el método centralizado del facade
        clinicalData: this._patientClinicalDataService.getAllPatientClinicalData(
          clinicHistory.patient.id,
          clinicHistory.id
        ),
      });
    })
  ).subscribe({
    next: ({ sell, patientInfo, clinicalData }) =>
    {
            console.log("ENTRA AL SUBSCRIBE DE  INITIALIZECLINICHISTORYDATA");

      this.clinicHistoryAsignedToSell = sell.clinicHistoryId;

      // — Patient information
      if (patientInfo) {
        this.patientInformation = patientInfo;
      }

      // — Datos clínicos (con tempId generado en un solo paso)
      this.relativeDiseases        = this.assignTempIds(clinicalData.relativeDiseases);
      this.patientAllergiesList     = this.assignTempIds(clinicalData.allergies);
      this.patientFarmacologicRecordsList = this.assignTempIds(clinicalData.farmacologicRecords);
      this.patientRiskFactorList    = this.assignTempIds(clinicalData.riskFactors);
      this.patientDiagnosticAllList = this.assignTempIds(clinicalData.diagnostics);
      this.chControlList            = this.assignTempIds(clinicalData.chControls);
      //this.chClinicHistoryObservationsList=this.assignTempIds(clinicalData.chObservations);
      console.log("EN INITIALIZECLINICHISTORYDATA, this.this.patientDiagnosticAllList ES:", this.patientDiagnosticAllList);

      // — Diagnóstico principal
      const principal = this.patientDiagnosticAllList.find(d => d.diagnosticCategory === 1);
      this.patientDiagnosticPrincipalList = principal ? [principal] : [];
      this.showDiagnosticPrincipal_ppal_component = true;

      //diagnosticios relacionados
      const related = this.patientDiagnosticAllList.filter(d => d.diagnosticCategory === 2);
      this.patientDiagnosticRelatedList = related;
      console.log("EN INITIALIZECLINICHISTORYDATA, this.patientDiagnosticRelatedList ES:", this.patientDiagnosticRelatedList);
      this.showDiagnosticRelated_ppal_component = true;

      // — Formulario
      this.patchPatientForm(this.patient);
      this.isSearchPatient = true;

        let listr=this.patientDiagnosticRelatedList;
       //utilizo el alias del Behavior Subject
        listr.length>0?this.sdrpd.next(true):this.sdrpd.next(false);







        if(this.categoryService=="cmg")
        {
          this.patientDiagnosticPrincipalFormGroup.patchValue({
            diagnosticType:"01",
          })

        }




      this._cdr.detectChanges();
    },
    error: (err) => {
      console.error('Error en initalizeClinicHistoryData:', err);
      // Aquí podrías mostrar un snackbar/toast al usuario
    }
  });
}

// ✅ Helper reutilizable: evita el forEach repetido 5 veces
private assignTempIds<T extends { tempId?: string }>(list: T[]): T[] {
  return list.map(x => ({ ...x, tempId: this.generarateGUI() }));
}

// ✅ Extrae el patchValue a método propio para no saturar la rutina principal
private patchPatientForm(patient: BOPerson): void
{
  this.firstFormGroup.patchValue({
    firstCtrl:   patient.firstName,
    secondCtrl:  patient.secondName,
    threeCtrl:   patient.firtsSurName,
    fourCtrl:    patient.secondSurName,
    fifthCtrl:   this.idTypeList.find(x => x.code === patient.idType)?.code,
    sixCtrl:     patient.personId,
    sevenCtrl:   patient.email,
    nineCtrl:    patient.address,
    eightCtrl:   patient.cellPhoneNumber,
    tenCtrl:     patient.emergencyContact,
    twelveCtrl:  patient.emergencyContactName,
    elevenCtrl:  patient.birthDate?.toString(),
  });
}






    //#endregion end NEW DATA NEW FORJOIN

    openSellModalFromClinicHistory():void
    {
      console.log("Entra a openSellModalCH");
      this.isFormModalOpen = true;

     let ch= this.clinicHistory;
     let bsell:BOSell= new BOSell();
     let idTypeConverted= this.idTypeList.find(x=>x.code==ch.patient.idType).id;
     bsell.sellDetails=[];

     let nameTemp=this.getNameFromClinichistory();
     bsell.userId=parseInt(ch.patient.personId);
    // bsell.idTypeIdentification=parseInt(ch.patient.idType),
     bsell.idTypeIdentification=idTypeConverted,

     bsell.userName=nameTemp;
     bsell.userEmail=ch.patient.email;
     bsell.dateSell=ch.consultationDate;
     bsell.clinicHistoryId=ch.id;
     bsell.total=ch.servicePrice;
     bsell.areaId=ch.area;
     bsell.userIdString=ch.patient.personId;

     let bsellDetail:BOSellDetail=new BOSellDetail();
     bsellDetail.profesionalId=ch.profesionalId;
     bsellDetail.serviceGroupId=parseInt(ch.serviceGroups);
     bsellDetail.serviceTypeId=parseInt(ch.serviceType);
     bsellDetail.price= ch.servicePrice;
     bsellDetail.sellDetailIdTemp=0;
     bsellDetail.subServicesDetails=[];
     bsell.sellDetails.push(bsellDetail)
     bsell.sellDetails[0].itemSaved=true;

     console.log("En openSellModalFromCH, bsell es:", bsell);

     this.sellModal.openSellModal(bsell, 1);

   }

   openRemissionModal(ch: BOClinicHistory, epss:BOEps[], patient:BOPerson, patientInformation: BOPatientInformation, company:BOCompany)
   {
      if(this.patientDiagnosticPrincipalList.length==0)
      {
        // this._patientDiagnosticService.getAllByPatientIdAndClinicId(patient.id, ch.id).subscribe({
        //   next:(data)=>
        //   {

        //     if(data.length==0 )
        //     {
        //       this.toastr.warning("Error", "No existe diagnóstico principal data.length=0");
        //       console.log("data es:", data);
        //      //return;
        //           ch.cei10="";
        //           ch.cei11="";
        //         this.remissionModal.openModal(ch,epss, patient, patientInformation, company, 'create','ch' );

        //     }
        //     else
        //     {
        //         this.patientDiagnosticPrincipalList=data;
        //         const existPpal= this.existsDiagnosticPrincipal(data);
        //         if(existPpal)
        //         {
        //           const ind=data.findIndex(x=>x.diagnosticCategory==1);
        //           const elm= data[ind];
        //           ch.cei10=elm.cie10Code;
        //           ch.cei11=elm.cie11Code;
        //         }
        //         else{
        //           this.toastr.error("Error", "No existe diagnóstico principal");
        //           return;
        //         }
        //     }




        //   }
        // })

            this.toastr.warning("Error", "No existe diagnóstico principal data.length=0");
             // console.log("data es:", data);
             //return;
                  ch.cei10="";
                  ch.cei11="";
                this.remissionModal.openModal(ch,epss, patient, patientInformation, company, 'create','ch' );
      }
      else //this.patientDiagnosticPrincipalList.length>0
      {
                console.log("Entra en this.pdp.length>0");

            const existPpal= this.existsDiagnosticPrincipal(this.patientDiagnosticPrincipalList);
            if(existPpal)
            {
              const ind=this.patientDiagnosticPrincipalList.findIndex(x=>x.diagnosticCategory===1);
              const elm= this.patientDiagnosticPrincipalList[ind];
               ch.cei10=elm.cie10Code;
               ch.cei11=elm.cie11Code;
            }
            else{
              this.toastr.warning("Error", "No existe diagnóstico principal");
              return;
            }


      }


        // ch.cei10= this.patientDiagnosticPrincipalList[0].cie10Code;
        // ch.cei11= this.patientDiagnosticPrincipalList[0].cie11Code;
    console.log("En OPENREMISSIONMODAL ch es:", ch );

    this.remissionModal.openModal(ch,epss, patient, patientInformation, company, 'create','ch' );
   }

   existsDiagnosticPrincipal(data:BODiagnosticNovo[]):boolean
   {
    return  data.some(x=>x.diagnosticCategory===1);
   }

   openInvoicesTaskModal(userId:string)
   {
      this.invoicesTask.ngOnInit2(userId);
   }

   onCloseFormModal() {
    this.isFormModalOpen = false; // Desactiva el sombreado


  // Resetear al cerrar
  this.isModalMode = true;
  this.ceiAgroupedListShort = [];
  // ... resto del código de cierre

  }


//#endregion open modal


    searchPatient(): void
    {
        const patientInput: BOPerson = {
            id: 0,
            idType: this.firstFormGroup.get('fifthCtrl')!.value,        //Id type
            personId: this.firstFormGroup.get('sixCtrl')!.value.trim(), //num Id
            personType: 3,
            isClient: true
        };
        this.busy = this._personService.getPersonIdNumber(patientInput).subscribe(data => {
            // if (data.id > 0 && data.idType==patientInput.idType)
            // {
            //   this.confirmCreateCopyPerson(data);
            // }

            if (data.id > 0)
            {
              this.confirmCreateCopyPerson(data);
            }
            // if (data.id > 0 && data.idType !=patientInput.idType)
            // {
            //    this.showPatientWithTypeDocumentActive(data.idType);
            // }
            this.isSearchPatient= true;
            this.isNav=true;

        });
    }


    confirmCreateCopyPerson(data:BOPerson):void
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('Este paciente ya está registrado.Si continua, creará una nueva historia con los datos de ese paciente.¿Desea crear una nueva historia? ')
      .afterClosed().subscribe({
        next:(res)=>
        {
          confirm=res;

          if(confirm)
          {
            this.patient = data;
            this.firstFormGroup.patchValue({
                firstCtrl: this.patient.firstName,
                secondCtrl: this.patient.secondName,
                threeCtrl: this.patient.firtsSurName,
                fourCtrl: this.patient.secondSurName,
                fifthCtrl: this.patient.idType,
                sixCtrl: this.patient.personId, //num Id
                sevenCtrl: this.patient.email,
                nineCtrl: this.patient.address,
                eightCtrl: this.patient.cellPhoneNumber,
                tenCtrl: this.patient.emergencyContact,
                twelveCtrl: this.patient.emergencyContactName,
                elevenCtrl: this.patient.birthDate.toString().split('T')[0]
            });

            this.isSearchPatient = true;
            this.showDiagnosticPrincipal_ppal_diseaseType=true;
            this.sdrpd.next(true); //utiliza el alias del BehaviorSubject

            //cargar antecedentes




          }
          else
          {
            this.close();
          }
        },
        error:(err)=>{
          console.log("Se produjo un error al confirmar si el paciente existe");
        }
      })


    }

    createOrUpdatePerson(next: boolean): void
    {
     console.log("ENTRA A CREATEORUPDATEPERSON SECONDFORMGROUP");

      this.isSaving=true;
      this.isLoading=true;

      if( this.categoryService=='cmg')
      {
              this.clinicHistory.clinicHistoryObservations=[];
              this.clinicHistory.medicalFormula=[];
      }

      if(this.categoryService =='edi')
      {
                this.sixFormGroup.patchValue({
                firstCtrl: this.clinicHistory.pathologicalRecord,
                secondCtrl: this.clinicHistory.consultationMotive,
                threeCtrl: this.clinicHistory.anamnesis,
                fourCtrl: this.clinicHistory.arterialPressure,
                fifthCtrl:this.clinicHistory.temperature,
                sixCtrl:this.clinicHistory.pulse,
                sevenCtrl:this.clinicHistory.weight,
                eightCtrl:this.clinicHistory.size,
                nineCtrl:this.clinicHistory.breathing,
                tenCtrl:this.clinicHistory.head,
                elevenCtrl:this.clinicHistory.neck,
                twelveCtrl:this.clinicHistory.chest,
                thirteenCtrl:this.clinicHistory.belly,
                fourteenCtrl:this.clinicHistory.pelvis,
                fiftheenCtrl:this.clinicHistory.extremities,
                sixteenCtrl:this.clinicHistory.skin,
                seventeenCtrl:this.clinicHistory.centralNervousSystem,
                eighteenCtrl:this.clinicHistory.diagnosticImpression,
                nineteenCtrl:this.clinicHistory.laboratoryControl,
                twentyCtrl:this.clinicHistory.treatmentPlan,
                twentyOneCtrl:this.clinicHistory.medicDiagnostic?.diseaseCode,
                twentyTwoCtrl:this.clinicHistory.medicDiagnostic?.orphanDisease,
                twentyThreeCtrl:this.clinicHistory.medicDiagnostic?.diagnosticType,
                diagnosticType: this.clinicHistory.diagnosticType,
                });

                this.destinationPatientFormGroup.patchValue({
                consultationDateEnd: this.clinicHistory.consultationDateEnd,
                patientConditionAndDestination:this.clinicHistory.patientConditionAndDestination,
                patientDestinationOrganization:this.clinicHistory.patientDestinationOrganization,
                patientDestinationOrganizationName:this.clinicHistory.patientDestinationOrganizationName

                })
      }


      let secondNameTested="";
      let secondNameTest=this.firstFormGroup.get('secondCtrl')!.value;
      if(typeof secondNameTest=="string") secondNameTest.trim();
      secondNameTest==null
        || secondNameTest==""
        || secondNameTest==undefined?secondNameTested="":(secondNameTested=secondNameTest.toUpperCase()).trim();

      let secondSurNameTest=(this.firstFormGroup.get('fourCtrl')!.value);
      if(typeof secondSurNameTest=="string") secondSurNameTest.trim();

      let secondSurNameTested="";
      secondSurNameTest ==null
        || secondSurNameTest ==""
        || secondSurNameTest==undefined?secondSurNameTested="":(secondSurNameTested=secondSurNameTest.toUpperCase()).trim();

        this.patient.id = this.patient.id;

        this.patient.firstName = this.firstFormGroup.get('firstCtrl')!.value;
        this.patient.firstName=this.patient.firstName.toUpperCase().trim();
        this.patient.secondName = secondNameTested;

        this.patient.firtsSurName = this.firstFormGroup.get('threeCtrl')!.value;
        this.patient.firtsSurName=this.patient.firtsSurName.toUpperCase().trim();

        this.patient.secondSurName = secondSurNameTested;
        this.patient.idType = this.firstFormGroup.get('fifthCtrl')!.value;
        this.patient.personId = (this.firstFormGroup.get('sixCtrl')!.value).toUpperCase();
        this.patient.email = (this.firstFormGroup.get('sevenCtrl')!.value).trim().toLowerCase();
        this.patient.address = this.firstFormGroup.get('nineCtrl')!.value;
        this.patient.cellPhoneNumber = String(this.firstFormGroup.get('eightCtrl')!.value);
        this.patient.emergencyContact = String(this.firstFormGroup.get('tenCtrl')!.value);
        this.patient.emergencyContactName = String(this.firstFormGroup.get('twelveCtrl')!.value);
        this.patient.birthDate = new Date(this.firstFormGroup.get('elevenCtrl')!.value);
        this.patient.personType = 3;
        this.patient.isClient = true;

        console.log("En CREATEORUPDATEPERSON this.patient es:",this.patient);

        if(this.categoryService=='cmc')
        {
            this.clinicHistory.id=0;
            this.clinicHistory.clinicHistoryObservations?.forEach(x => { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) });
            this.clinicHistory.medicalFormula?.forEach(x => { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id'))  });
        }

        this.busy = this._personService.addOrUpdatePerson(this.patient)
        .pipe(
          finalize(() => {
            this.isLoading = false;
            this.isSaving = false;
            this._cdr.detectChanges();
          })
        )
        .subscribe({
          next:(data) =>
          {
            this.patient.id = data;

            if (this.clinicHistory.id == 0)
            {
                this._clinicHistoryService.createClinicHistory(this.patient.id,1)
                .subscribe(data =>
                {
                    this.clinicHistory.id = data;
                    if (this.patient.patientInformationId != null)
                    {
                        var stateCodeTemp = null;
                        this._patientInformationService.getPatientInformation(this.patient.patientInformationId)
                        .pipe(
                            finalize(() => {
                              this.isLoading = false;
                              this.isSaving = false;
                              this._cdr.detectChanges();
                            })
                        )
                        .subscribe({
                          next:(data) =>
                          {
                            this.patientInformation = data;

                            if (this.cities.find(ci => ci.id == this.patientInformation.residenceCityId) != undefined)
                            {
                                stateCodeTemp = this.cities.find(ci => ci.id == this.patientInformation.residenceCityId).code.substring(0, 2);
                                this._cityService.getCitiesbyState(stateCodeTemp)
                                .subscribe(data => {
                                    this.cities = data;
                                })
                            }
                            else
                            {
                                this.cities = [];
                            }

                            this.secondFormGroup.patchValue({
                                firstCtrl: this.patientInformation.sexType,
                                secondCtrl: this.patientInformation.genderIdentity,
                                threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
                                fourCtrl: this.patientInformation.ethnicity,
                                fifthCtrl: this.patientInformation.ethnicCommunity,
                                sixCtrl: this.patientInformation.residenceZone,
                                sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
                                nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
                                eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
                                tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
                                elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
                                twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
                                thirteen: this.patientInformation.organDonor?.organDonorAnswer,
                                fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
                                fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
                                sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
                            });

                            //Ric
                            this.thirdFormGroup.patchValue({
                                secondCtrl:"7600108820",
                                threeCtrl: "01",
                                fourCtrl: "05"
                            });

                            if (this.epsList.find(x => x.id == this.patientInformation.epsId)?.code != undefined) {
                                this.epsFilterCtrl.setValue(this.epsList.find(x => x.id == this.patientInformation.epsId).name);
                            }
                            if (this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code != undefined) {
                                this.ocupationFilterCtrl.setValue(this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId).description);
                            }
                            if (this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code != undefined) {
                                this.countryFilterCtrl.setValue(this.countries.find(co => co.id == this.patientInformation.residenceCountryId).name);
                            }
                            if (next)
                            {
                              this.stepper.next();
                            }
                            else
                            {
                              this.close();

                            }
                        },
                        error:(err)=>{
                          console.log("Ocurrió error subscribe interior");
                        }
                    }); ///

                    }
                    else
                    {
                        this.patientInformation.id = 0;
//Ric
                        this.secondFormGroup.patchValue({
                        firstCtrl:  "02",
                        secondCtrl: "02",
                        threeCtrl:  "08",
                        fourCtrl:   "06",//etnia
                        fifthCtrl:  "06",//gruupo etnico
                        sixCtrl: "01",
                        nineCtrl: '5169', //ocupación

                        eightCtrl: "170",
                        tenCtrl: "170",
                        elevenCtrl: "",
                        });

                        this.thirdFormGroup.patchValue({
                        secondCtrl:"7600108820",
                        threeCtrl: "01",
                        fourCtrl: "05"
                        });
                        this._cdr.detectChanges();

                        this.cities = [];
                        if (next)
                        {
                            this.isLoading = false;
                            this.isSaving = false;
                            this.stepper.next();
                        }
                        else
                        {
                            this.isLoading = false;
                            this.isSaving = false;
                            this.close();
                        }
                    }
                });
            }
            //end if (this.clinicHistory.id == 0)

            else
            {
                if (this.patient.patientInformationId != null)
                {
                    var stateCodeTemp = null;
                    this._patientInformationService.getPatientInformation(this.patient.patientInformationId)
                    .subscribe({
                      next:(data) =>
                      {
                        this.patientInformation = data;
                        if (this.cities.find(ci => ci.id == this.patientInformation.residenceCityId) != undefined)
                        {
                            stateCodeTemp = this.cities.find(ci => ci.id == this.patientInformation.residenceCityId).code.substring(0, 2);
                            this._cityService.getCitiesbyState(stateCodeTemp).subscribe(data => {
                                this.cities = data;
                            })
                        }
                        else {
                            this.cities = [];
                        }
                        this.secondFormGroup.patchValue({
                            firstCtrl: this.patientInformation.sexType,
                            secondCtrl: this.patientInformation.genderIdentity,
                            threeCtrl: this.patientInformation.disabilityCategory != null ? this.patientInformation.disabilityCategory : "08",
                            fourCtrl: this.patientInformation.ethnicity,
                            fifthCtrl: this.patientInformation.ethnicCommunity,
                            sixCtrl: this.patientInformation.residenceZone,
                            sevenCtrl: this.epsList.find(x => x.id == this.patientInformation.epsId)?.code,
                            nineCtrl: this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code,
                            eightCtrl: this.countries.find(c => c.id == this.patientInformation.birthCountryId)?.code,
                            tenCtrl: this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code,
                            elevenCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code,
                            twelveCtrl: this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2),
                            thirteen: this.patientInformation.organDonor?.organDonorAnswer,
                            fourtheen: this.patientInformation.organDonor?.organDonorDocumentDate?.toString().split('T')[0],
                            fiftheen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentAnswer,
                            sixteen: this.patientInformation.advancedDirectiveDocument?.advancedDirectiveDocumentDate?.toString().split('T')[0]
                        });
                        if (this.epsList.find(x => x.id == this.patientInformation.epsId)?.code != undefined) {
                            this.epsFilterCtrl.setValue(this.epsList.find(x => x.id == this.patientInformation.epsId).name);
                        }
                        if (this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId)?.code != undefined) {
                            this.ocupationFilterCtrl.setValue(this.personOcupationList.find(p => p.id == this.patientInformation.personOcupationId).description);
                        }
                        if (this.countries.find(co => co.id == this.patientInformation.residenceCountryId)?.code != undefined) {
                            this.countryFilterCtrl.setValue(this.countries.find(co => co.id == this.patientInformation.residenceCountryId).name);
                        }
                        //this.toastr.success('Informacion del Paciente Actualizada', 'Informacion del Paciente Actualizada Exitosamente');
                        if (next)
                        {
                            this.isLoading = false;
                            this.isSaving = false;
                            this._cdr.detectChanges();

                          this.stepper.next();
                        }
                        else
                        {
                          this.isLoading = false;
                          this.isSaving = false;
                          this.close();
                        }
                    },
                    error:(err)=>{
                      console.log("Error en ch >0");
                    }
                });//

                }
                // End of if (this.patient.patientInformationId != null)
                else
                {
                  this.patientInformation.id = 0;
                //Ric
                  this.secondFormGroup.patchValue({
                        firstCtrl:  "02",
                        secondCtrl: "02",
                        threeCtrl:  "08",
                        fourCtrl:   "99",
                        fifthCtrl:  "",
                        sixCtrl: "01",
                        nineCtrl: '5169',
                        eightCtrl: "170",
                        tenCtrl: "170",
                        elevenCtrl: "",
                    });
                //Ric

                    this.cities = [];
                    this.toastr.success('Informacion del Paciente Actualizada', 'Informacion del Paciente Actualizada Exitosamente');
                    // if (next) this.stepper.next();
                    // else this.close();
                        if (next)
                        {
                            this.isLoading = false;
                            this.isSaving = false;
                            this.stepper.next();
                        }
                        else
                        {
                          this.isLoading = false;
                          this.isSaving = false;
                          this.close();
                        }
                }
            }

          },
          error: (err)=>{

            this.isLoading=false;
            this.isSaving=false;
            console.log("Error al crear o actualizar Person")
          }

        });
    }
//#region CreateOrUpdatePatienInformation
    createOrUpdatePatientInformation(next: boolean): void
    {
        this.isLoading=true;
        this.isSaving=true;
        console.log("Entra a COUPATIENTINFORMATION, ocupa es:",this.secondFormGroup.get('nineCtrl').value != undefined ? this.personOcupationList.find(e => e.code == this.secondFormGroup.get('nineCtrl').value)?.id : undefined, )
        const patientInformationInput: BOPatientInformation =
        {
            id: this.patientInformation.id,
            sexType: this.secondFormGroup.get('firstCtrl')!.value,
            genderIdentity: this.secondFormGroup.get('secondCtrl').value,
            disabilityCategory: this.secondFormGroup.get('threeCtrl').value,
            ethnicity: this.secondFormGroup.get('fourCtrl').value,
            ethnicCommunity: this.secondFormGroup.get('fifthCtrl').value,
            residenceZone: this.secondFormGroup.get('sixCtrl').value,
            epsId: this.secondFormGroup.get('sevenCtrl').value != undefined ? this.epsList.find(e => e.code == this.secondFormGroup.get('sevenCtrl').value)?.id : undefined,
            birthCountryId: this.secondFormGroup.get('eightCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('eightCtrl').value)?.id : undefined,
            personOcupationId: this.secondFormGroup.get('nineCtrl').value != undefined ? this.personOcupationList.find(e => e.code == this.secondFormGroup.get('nineCtrl').value)?.id : undefined,
            residenceCountryId: this.secondFormGroup.get('tenCtrl').value != undefined ? this.countries.find(e => e.code == this.secondFormGroup.get('tenCtrl').value)?.id : undefined,
            residenceCityId: this.secondFormGroup.get('elevenCtrl').value != undefined ? this.cities.find(e => e.code == this.secondFormGroup.get('elevenCtrl').value)?.id : undefined
        };

        if (this.patientInformation.organDonor != null) {
            patientInformationInput.organDonor = this.patientInformation.organDonor;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        else {
            patientInformationInput.organDonor = new BOOrganDonor();
            patientInformationInput.organDonor.id = 0;
            patientInformationInput.organDonor.organDonorAnswer = this.secondFormGroup.get('thirteen').value;
            patientInformationInput.organDonor.organDonorDocumentDate = this.secondFormGroup.get('fourtheen').value != undefined ? new Date(this.secondFormGroup.get('fourtheen').value) : null;
        }
        if (this.patientInformation.advancedDirectiveDocument != null) {
            patientInformationInput.advancedDirectiveDocument = this.patientInformation.advancedDirectiveDocument;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }
        else
        {
            patientInformationInput.advancedDirectiveDocument = new BOAdvancedDirectiveDocument();
            patientInformationInput.advancedDirectiveDocument.id = 0;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentAnswer = this.secondFormGroup.get('fiftheen').value;
            patientInformationInput.advancedDirectiveDocument.advancedDirectiveDocumentDate = this.secondFormGroup.get('sixteen').value != undefined ? new Date(this.secondFormGroup.get('sixteen').value) : null;
        }

        this.busy = this._patientInformationService.addOrUpdatePatientInformation(patientInformationInput)
        .pipe(
          finalize(() => {
            this.isLoading = false;
            this.isSaving = false;
            this._cdr.detectChanges();
          })
        )
        .subscribe({
          next:(data) =>
          {

              if (this.categoryService=="cmg")
              {
                this.profesionalSelected=null;
                this.areaSelected=1;

                  this.thirdFormGroup.patchValue({
                      firstCtrl: new Date(),
                      secondCtrl: "7600108820",
                      threeCtrl: null,
                      fourCtrl: "01",
                      fifthCtrl:"05",
                      sixCtrl:"01",
                      sevenCtrl:"38",
                      thirteenCtrl: "01",
                      fourteenCtrl: 0,
                  });

              }

              if (this.categoryService=="cmc")
              {
                  this.thirdFormGroup.patchValue({

                      firstCtrl: null,
                      secondCtrl: this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code,
                      threeCtrl: "01",
                      fourCtrl: this.clinicHistory.healthTechnologyModality,
                      fifthCtrl: this.clinicHistory.placeOfAttention,
                      sixCtrl: this.clinicHistory.routeOfEntry,
                      sevenCtrl: this.clinicHistory.consultationCause,
                      eightCtrl: this.clinicHistory.triageDate,
                      nineCtrl: this.clinicHistory.triageType,
  //                   thirteenCtrl: "37",
                      thirteenCtrl: "37",
                      fourteenCtrl: 0,
                      fifteenCtrl: "Consulta de control médico"

                  });

              }

              if (this.categoryService=="edi")
              {
              const conDate=this.clinicHistory.consultationDate?.toString();
              const code =this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.code;

                this.thirdFormGroup.patchValue({
                  firstCtrl: conDate?? new Date(),
                  secondCtrl: code?? "7600108820",
                  threeCtrl: this.clinicHistory.serviceGroups,
                  fourCtrl: this.clinicHistory.healthTechnologyModality?? "01",
                  fifthCtrl: this.clinicHistory.placeOfAttention?? "05",
                  sixCtrl: this.clinicHistory.routeOfEntry?? "01",
                  sevenCtrl: this.clinicHistory.consultationCause?? "38",
                  eightCtrl: this.clinicHistory.triageDate,
                  nineCtrl: this.clinicHistory.triageType,
                  thirteenCtrl: this.clinicHistory.serviceType?? "01",
                  fourteenCtrl: this.clinicHistory.servicePrice?? 0,
                  fifteenCtrl: this.clinicHistory.procedureDescription,
                  seventeenCtrl:this.clinicHistory.area
              });

              }

              //  this.showOtherProcedureControl = this.clinicHistory.serviceType == "24" ? true : false;

              if (this.clinicHistory.medicDiagnostic?.diseaseCode != null) {
                      this.diseaseFilterCtrl.setValue(this.clinicHistory.medicDiagnostic.diseaseCode);
              }

              if (this.clinicHistory.medicDiagnostic?.orphanDisease != null) {
                      this.orphanDiseaseFilterCtrl.setValue(this.clinicHistory.medicDiagnostic.orphanDisease);
              }

              if (this.patientInformation.id > 0)
              {
                  // if (next) this.stepper.next();
                  //  else this.close();
                  if (next)
                  {
                      this.isLoading = false;
                      this.isSaving = false;
                      this.stepper.next();
                  }
                  else
                  {
                    this.isLoading = false;
                    this.isSaving = false;
                    this.close();
                  }
              }
              else
              {
                this.patientInformation.id = data;
                this.patient.patientInformationId = data;

                this._personService.addOrUpdatePerson(this.patient).subscribe(data => {
                  if (next)
                  {
                      this.isLoading = false;
                      this.isSaving = false;
                      this.stepper.next();
                  }
                  else
                  {
                    this.isLoading = false;
                    this.isSaving = false;
                    this.close();
                  }

                });

              }
          },
          error:(err)=>{
            console.log("Error al crear o actualizar la info del paciente");
          }
        }); //
    }

//#endregion

//#region updateClinicHistory
    updateClinicHistory(next: boolean, step: string, closeMode?:string): void
    {
              // ✅ PREVENCIÓN DE MÚLTIPLES CLICKS
        if (this.isSaving) {
          this.toastr.warning('Operación en curso', 'Por favor espere a que se complete el guardado');
          return;
        }
        //

        if(step=="2")
        {
   //       if(this.profesionalSelected==null || this.profesionalSelected==undefined){
            if(this.profesionalSelected==null || this.profesionalSelected==undefined  )
            {
             this.toastr.error('Profesional no seleccionado', 'Debe elegir un profesional');

            }
            else{


            this.updateClinicHistoryBody(next,step);

            }
        }
        else
        {
            this.updateClinicHistoryBody(next,step);
        }

    }
    updateClinicHistoryBody(next: boolean, step: string, closeMode?:string):void
    {
      console.log("ENTRA A UPDATECLINICHISTORYBODY");
      this.clinicHistory.clinicHistoryObservations?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      this.clinicHistory.medicalFormula?.forEach(x => { if (x.id < 0) { x.id = 0; x.creationUserId = parseInt(localStorage?.getItem('Id')) } });
      try
      {
          this.isSaving = true;
        //  if (this.showOnlyObservations)
          if (this.stepper.selectedIndex==7)
          {
              this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString())
              .pipe(
                  finalize(() => {
                    //STOP
                          this.selectedCodeIcd10="";
                          this.selectedGroupCodeIcd11="";
                    this.isLoading = false;
                    this.isSaving = false;
                    this._cdr.detectChanges();
                  })
               )
              .subscribe({
                  next:data =>
                  {
                    this.isSaving = false;
                    this._cdr.detectChanges();
                   // this.close();
                  },
                  error:(err)=>{
                    console.log("Ocurrió un error subscribe onlyObservations");
                  }

               });
          }
          else // if (this.stepper.selectedIndex!=7)
          {
             //asigna this.clinicHistoryAsignedToSell
              this._sellService.getSellByClinicHistoryId(this.clinicHistory.id).subscribe({
                next:(data)=>
                {
                this.clinicHistoryAsignedToSell=data.clinicHistoryId;
                this._cdr.detectChanges();
                },
                error:(err)=>{
                  console.log("Ocurrió un error");
                }
              });


              if(this.categoryService=="cmg" || this.categoryService=="cmc")
              {
                var servicePriceFormatted=0.00;
                var diagnosticITTemp=-1;
                let patientConditionAndDestinationTemp="";
                let patientDestinationOrganizationTemp="";
                let patientDestinationOrganizationNameTemp="";



                if(this.patientDiagnosticPrincipalList.length>0)
                {

                  diagnosticITTemp=this.patientDiagnosticPrincipalList[0].diagnosticType;

                }
                else{

                  diagnosticITTemp=this.patientDiagnosticPrincipalFormGroup.get('diagnosticType').value;

                }

                if(this.categoryService=='cmg')
                {
                  const value = this.thirdFormGroup.get('fourteenCtrl')!.value;
                  var numericValue = parseFloat(value); // Convertir a número

                  // Verificar si la conversión fue exitosa
                  if (!isNaN(numericValue))
                  {
                    servicePriceFormatted = parseFloat(numericValue.toFixed(2));
                  } else
                  {
                    this.toastr.error('Error', 'Error de formato en el número');
                    return;
                  }

                  if(this.stepper.selectedIndex>=5)
                  {
                    patientConditionAndDestinationTemp= this.destinationPatientFormGroup.get('patientConditionAndDestination')!.value;
                    patientDestinationOrganizationTemp= this.destinationPatientFormGroup.get('patientDestinationOrganization')!.value;
                    patientDestinationOrganizationNameTemp=this.destinationPatientFormGroup.get('patientDestinationOrganizationName')!.value;

                  }



                }

                const clnicHistoryInput: BOClinicHistory = {
                    id: this.clinicHistory.id,
                    patientId: this.patient.id,
                    profesional:this.profesionals.find(x => x.id == this.profesionalSelected),
                    area:this.areaSelected,

                    consultationDate: new Date(this.thirdFormGroup.get('firstCtrl')!.value),
                    ipsId: this.ipsList.find(x => x.code == this.thirdFormGroup.get('secondCtrl')!.value).id,
                    serviceGroups: this.thirdFormGroup.get('threeCtrl')!.value,
                    healthTechnologyModality: this.thirdFormGroup.get('fourCtrl')!.value,
                    placeOfAttention: this.thirdFormGroup.get('fifthCtrl')!.value,
                    routeOfEntry: this.thirdFormGroup.get('sixCtrl')!.value,
                    consultationCause: this.thirdFormGroup.get('sevenCtrl')!.value,
                    triageDate: new Date(this.thirdFormGroup.get('eightCtrl')!.value),
                    triageType: this.thirdFormGroup.get('nineCtrl')!.value,
                    clinicHistoryObservations: this.clinicHistory.clinicHistoryObservations,
                    medicalFormula: this.clinicHistory.medicalFormula,
                    serviceType: this.thirdFormGroup.get('thirteenCtrl')!.value,
                    servicePrice:servicePriceFormatted,
                    procedureDescription: this.thirdFormGroup.get('fifteenCtrl')!.value,
                    pathologicalRecord: this.sixFormGroup.get('firstCtrl')!.value,
                    consultationMotive: this.sixFormGroup.get('secondCtrl')!.value,
                    anamnesis: this.sixFormGroup.get('threeCtrl')!.value,
                    arterialPressure: this.sixFormGroup.get('fourCtrl')!.value,
                    temperature: this.sixFormGroup.get('fifthCtrl')!.value,
                    pulse: this.sixFormGroup.get('sixCtrl')!.value,
                    weight: this.sixFormGroup.get('sevenCtrl')!.value,
                    size: this.sixFormGroup.get('eightCtrl')!.value,
                    breathing: this.sixFormGroup.get('nineCtrl')!.value,
                    head: this.sixFormGroup.get('tenCtrl')!.value,
                    neck: this.sixFormGroup.get('elevenCtrl')!.value,
                    chest: this.sixFormGroup.get('twelveCtrl')!.value,
                    belly: this.sixFormGroup.get('thirteenCtrl')!.value,
                    pelvis: this.sixFormGroup.get('fourteenCtrl')!.value,
                    extremities: this.sixFormGroup.get('fiftheenCtrl')!.value,
                    skin: this.sixFormGroup.get('sixteenCtrl')!.value,
                    centralNervousSystem: this.sixFormGroup.get('seventeenCtrl')!.value,
                    diagnosticImpression: this.sixFormGroup.get('eighteenCtrl')!.value,
                    laboratoryControl: this.sixFormGroup.get('nineteenCtrl')!.value,
                    treatmentPlan: this.sixFormGroup.get('twentyCtrl')!.value,
                    isPaidMethod:this.clinicHistory.isPaidMethod,
                    //
                    controlConsultation: 0,
                    diagnosticType: Utilities.ConvertNumberToString(diagnosticITTemp),

                    consultationDateEnd: new Date(this.destinationPatientFormGroup.get('consultationDateEnd')!.value),
                    patientConditionAndDestination: patientConditionAndDestinationTemp,
                    patientDestinationOrganization: patientDestinationOrganizationTemp,
                    patientDestinationOrganizationName: patientDestinationOrganizationNameTemp,

                }

                console.log("EN UPDACLINICHISTORYBODY, EN PASO:", this.stepper.selectedIndex, "En Tipo:", this.categoryService,
                " LA CH a enviar es:", this.BOClinicHistoryInput);


                if (this.clinicHistory.medicDiagnostic != null) {
                    clnicHistoryInput.medicDiagnostic = this.clinicHistory.medicDiagnostic;
                    clnicHistoryInput.medicDiagnostic.diseaseCode = this.sixFormGroup.get('twentyOneCtrl')!.value;
                    clnicHistoryInput.medicDiagnostic.orphanDisease = this.sixFormGroup.get('twentyTwoCtrl')!.value;
                    clnicHistoryInput.medicDiagnostic.diagnosticType = this.sixFormGroup.get('twentyThreeCtrl')!.value;
                }
                else
                {
                    clnicHistoryInput.medicDiagnostic = new BOMedicDiagnostic();
                    clnicHistoryInput.medicDiagnostic.id = 0;
                    clnicHistoryInput.medicDiagnostic.diseaseCode = this.sixFormGroup.get('twentyOneCtrl')!.value;
                    clnicHistoryInput.medicDiagnostic.orphanDisease = this.sixFormGroup.get('twentyTwoCtrl')!.value;
                    clnicHistoryInput.medicDiagnostic.diagnosticType = this.sixFormGroup.get('twentyThreeCtrl')!.value;
                }

                if(this.categoryService=='cmg')//consulta médica general
                {
                  //valida si existe un diagnóstico principal
                  if(this.stepper.selectedIndex==5)
                  {
                      if(this.existsDiagnosticPrincipal(this.patientDiagnosticPrincipalList))
                      {

                      }
                      else
                      {
                        this.toastr.warning("Fallo", "No existe diagnóstico principal");

                      }
                  }


                  this.busy = this._clinicHistoryService.updateClinicHistory(clnicHistoryInput, this.stepper.selectedIndex.toString())
                  .pipe(
                      finalize(() => {
                        this.isLoading = false;
                        this.isSaving = false;
                        this._cdr.detectChanges();
                      })
                  )
                  .subscribe({
                    next:(data) =>
                    {
                        this._clinicHistoryService.getClinicHistory(this.clinicHistory.id)
                        .pipe(
                            finalize(() => {
                              this.isLoading = false;
                              this.isSaving = false;
                              this._cdr.detectChanges();
                            })
                        )
                        .subscribe({
                          next:(data) =>
                          {
                              this.clinicHistory = data;

                              if (this.clinicHistory.healthTechnologies != null)
                              {
                                  this.fourFormGroup.patchValue({
                                      firstCtrl: this.clinicHistory.healthTechnologies.healthTechnology,
                                      secondCtrl: this.clinicHistory.healthTechnologies.healthTecnologyFinality,
                                      threeCtrl: this.clinicHistory.healthTechnologies.prescriptionDate,
                                      fourCtrl: this.clinicHistory.healthTechnologies.healthTecnologyMedicamentDescription,
                                      fifthCtrl: this.clinicHistory.healthTechnologies.prescriptionMedicationDose.quantity,
                                      sixCtrl: this.clinicHistory.healthTechnologies.prescriptionMedicationDose.measurementMedicationUnits,
                                      sevenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyVad,
                                      eightCtrl: this.clinicHistory.healthTechnologies.healthTechnologyTerm.quantity,
                                      nineCtrl: this.clinicHistory.healthTechnologies.healthTechnologyTerm.timeUnit,
                                      tenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.quantity,
                                      elevenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.timeUnit,
                                      twelveCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.quantity,
                                      thirteenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.measurementMedicationUnits,
                                      fourteenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredDate,
                                      sixteenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.measurementMedicationUnits,
                                      fiftheenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.quantity,
                                      seventeenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.quantity,
                                      eighteenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.measurementMedicationUnits,
                                  });
                              }
                              else
                              {
                                  this.fourFormGroup.patchValue({
                                      fifthCtrl: 0,
                                      eightCtrl: 0,
                                      tenCtrl: 0,
                                      twelveCtrl: 0,
                                      fiftheenCtrl: 0,
                                      seventeenCtrl: 0
                                  });
                              }

                              if (next)
                              {
                                if (this.stepper.selectedIndex != 7 && this.stepper.selectedIndex < 8)
                                {
                                  this.isSaving = false;
                                  this.stepper.next();
                                }
                              }
                              else
                              {
                                  this.isSaving = false;
                                  this.close();
                              }
                          },
                              error:(err)=>{
                              console.log("Se descubrió un error")
                          }
                        });
                    },
                    error:(err)=>{
                      console.log("Se descubrió error");
                    }
                  });
                }

              }

              else //entra a edit
              {
                  //const servicePriceFormatted = parseFloat(this.thirdFormGroup.get('fourteenCtrl')!.value.toFixed(2));
                  const servicePriceFormatted = this.thirdFormGroup.get('fourteenCtrl')!.value;

                  // if(this.stepper.selectedIndex==5)
                  // {
                  //   this.selectedCodeIcd10= this.getDataCei10();
                  //   this.selectedGroupCodeIcd11=this.getDataCei11();
                  // }
                  console.log('En ln 2473 de uCH,this.ipsList es:', this.ipsList);
                  const clnicHistoryInput: BOClinicHistory = {
                        id: this.clinicHistory.id,
                        isPaidMethod:this.clinicHistory.isPaidMethod,
                        isOdontograma:this.clinicHistory.isOdontograma,
                        patientId: this.patient.id,
                        profesional:this.profesionals.find(x => x.id == this.profesionalSelected),
                        area:this.areaSelected,
                        consultationDate: new Date(this.thirdFormGroup.get('firstCtrl')!.value),
                        ipsId: this.ipsList.find(x => x.code == this.thirdFormGroup.get('secondCtrl')!.value).id,
                        serviceGroups: this.thirdFormGroup.get('threeCtrl')!.value,
                        healthTechnologyModality: this.thirdFormGroup.get('fourCtrl')!.value,
                        placeOfAttention: this.thirdFormGroup.get('fifthCtrl')!.value,
                        routeOfEntry: this.thirdFormGroup.get('sixCtrl')!.value,
                        consultationCause: this.thirdFormGroup.get('sevenCtrl')!.value,
                        triageDate: new Date(this.thirdFormGroup.get('eightCtrl')!.value),
                        triageType: this.thirdFormGroup.get('nineCtrl')!.value,
                        clinicHistoryObservations: this.clinicHistory.clinicHistoryObservations,
                        medicalFormula: this.clinicHistory.medicalFormula,
                        serviceType: this.thirdFormGroup.get('thirteenCtrl')!.value,
                        servicePrice: servicePriceFormatted,
                        procedureDescription: this.thirdFormGroup.get('fifteenCtrl')!.value,
                        pathologicalRecord: this.sixFormGroup.get('firstCtrl')!.value,
                        consultationMotive: this.sixFormGroup.get('secondCtrl')!.value,
                        anamnesis: this.sixFormGroup.get('threeCtrl')!.value,
                        arterialPressure: this.sixFormGroup.get('fourCtrl')!.value,
                        temperature: this.sixFormGroup.get('fifthCtrl')!.value,
                        pulse: this.sixFormGroup.get('sixCtrl')!.value,
                        weight: this.sixFormGroup.get('sevenCtrl')!.value,
                        size: this.sixFormGroup.get('eightCtrl')!.value,
                        breathing: this.sixFormGroup.get('nineCtrl')!.value,
                        head: this.sixFormGroup.get('tenCtrl')!.value,
                        neck: this.sixFormGroup.get('elevenCtrl')!.value,
                        chest: this.sixFormGroup.get('twelveCtrl')!.value,
                        belly: this.sixFormGroup.get('thirteenCtrl')!.value,
                        pelvis: this.sixFormGroup.get('fourteenCtrl')!.value,
                        extremities: this.sixFormGroup.get('fiftheenCtrl')!.value,
                        skin: this.sixFormGroup.get('sixteenCtrl')!.value,
                        centralNervousSystem: this.sixFormGroup.get('seventeenCtrl')!.value,
                        diagnosticImpression: this.sixFormGroup.get('eighteenCtrl')!.value,
                        laboratoryControl: this.sixFormGroup.get('nineteenCtrl')!.value,
                        treatmentPlan: this.sixFormGroup.get('twentyCtrl')!.value,
                        controlConsultation:this.clinicHistory.controlConsultation,
                        diagnosticType: Utilities.ConvertNumberToString(diagnosticITTemp),

                        consultationDateEnd: new Date(this.destinationPatientFormGroup.get('consultationDateEnd')!.value),
                        patientConditionAndDestination: this.clinicHistory.patientConditionAndDestination,
                        patientDestinationOrganization: this.clinicHistory.patientDestinationOrganization,
                        patientDestinationOrganizationName: this.clinicHistory.patientDestinationOrganizationName,
                  }

                  if(this.stepper.selectedIndex>=5)
                  {
                    clnicHistoryInput.patientConditionAndDestination= this.destinationPatientFormGroup.get('patientConditionAndDestination')!.value;
                    clnicHistoryInput.patientDestinationOrganization= this.destinationPatientFormGroup.get('patientDestinationOrganization')!.value;
                    clnicHistoryInput.patientDestinationOrganizationName=this.destinationPatientFormGroup.get('patientDestinationOrganizationName')!.value;

                  }

                  if(this.stepper.selectedIndex==5)
                  {
                  if(this.existsDiagnosticPrincipal(this.patientDiagnosticPrincipalList))
                  {
                  	console.log("Existe diagnóstico principal");
                  }
                  else
                  {
                    this.toastr.warning("Fallo", "No existe diagnóstico principal");

                  }
                  }




                console.log("EN UPDACLINICHISTORYBODY, EN PASO:", this.stepper.selectedIndex, "En Tipo:", this.categoryService,
                " LA CH a enviar es:", clnicHistoryInput);
                  if (this.clinicHistory.medicDiagnostic != null) {
                      clnicHistoryInput.medicDiagnostic = this.clinicHistory.medicDiagnostic;
                      clnicHistoryInput.medicDiagnostic.diseaseCode = this.sixFormGroup.get('twentyOneCtrl')!.value;
                      clnicHistoryInput.medicDiagnostic.orphanDisease = this.sixFormGroup.get('twentyTwoCtrl')!.value;
                      clnicHistoryInput.medicDiagnostic.diagnosticType = this.sixFormGroup.get('twentyThreeCtrl')!.value;
                  }
                  else
                    {
                      clnicHistoryInput.medicDiagnostic = new BOMedicDiagnostic();
                      clnicHistoryInput.medicDiagnostic.id = 0;
                      clnicHistoryInput.medicDiagnostic.diseaseCode = this.sixFormGroup.get('twentyOneCtrl')!.value;
                      clnicHistoryInput.medicDiagnostic.orphanDisease = this.sixFormGroup.get('twentyTwoCtrl')!.value;
                      clnicHistoryInput.medicDiagnostic.diagnosticType = this.sixFormGroup.get('twentyThreeCtrl')!.value;
                  }

                  this.busy = this._clinicHistoryService
                  .updateClinicHistory(clnicHistoryInput, this.stepper.selectedIndex.toString())
                  .pipe(
                      finalize(() => {
                        this.isLoading = false;
                        this.isSaving = false;
                        this._cdr.detectChanges();
                      })
                  )
                  .subscribe({
                    next:(data) =>
                    {
                        this._clinicHistoryService.getClinicHistory(this.clinicHistory.id)
                        .pipe(
                            finalize(() => {
                              this.isLoading = false;
                              this.isSaving = false;
                              this._cdr.detectChanges();
                            })
                        )
                        .subscribe({
                          next:(data) =>
                          {
                              this.clinicHistory = data;
                              if (this.clinicHistory.healthTechnologies != null)
                              {
                                this.fourFormGroup.patchValue(
                                {
                                    firstCtrl: this.clinicHistory.healthTechnologies.healthTechnology,
                                    secondCtrl: this.clinicHistory.healthTechnologies.healthTecnologyFinality,
                                    threeCtrl: this.clinicHistory.healthTechnologies.prescriptionDate,
                                    fourCtrl: this.clinicHistory.healthTechnologies.healthTecnologyMedicamentDescription,
                                    fifthCtrl: this.clinicHistory.healthTechnologies.prescriptionMedicationDose.quantity,
                                    sixCtrl: this.clinicHistory.healthTechnologies.prescriptionMedicationDose.measurementMedicationUnits,
                                    sevenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyVad,
                                    eightCtrl: this.clinicHistory.healthTechnologies.healthTechnologyTerm.quantity,
                                    nineCtrl: this.clinicHistory.healthTechnologies.healthTechnologyTerm.timeUnit,
                                    tenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.quantity,
                                    elevenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.timeUnit,
                                    twelveCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.quantity,
                                    thirteenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.measurementMedicationUnits,
                                    fourteenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredDate,
                                    sixteenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.measurementMedicationUnits,
                                    fiftheenCtrl: this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.quantity,
                                    seventeenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.quantity,
                                    eighteenCtrl: this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.measurementMedicationUnits,
                                });
                              }
                              else
                              {
                                this.fourFormGroup.patchValue({
                                    fifthCtrl: 0,
                                    eightCtrl: 0,
                                    tenCtrl: 0,
                                    twelveCtrl: 0,
                                    fiftheenCtrl: 0,
                                    seventeenCtrl: 0
                                });
                              }

                              if (next)
                              {
                                if (this.stepper.selectedIndex != 7 && this.stepper.selectedIndex < 8)
                                {
                                    this.isSaving = false;
                                    this.stepper.next();
                                }
                              }
                              else
                              {
                                this.isSaving = false;
                                this.close();

                              }

                          },
                          error:(err)=>
                          {
                            console.log("Error en subscribe interior 1")
                          }

                        }) //end subscribe interior 1

                    },
                    error:(err)=>
                    {
                      this.toastr.error("Error", "Revise los campos obligatorios")
                    }


                  }); // end subscribe exterior

                }

          }
      }
      catch(error)
      {
          this.isSaving = false;
          this.errorMessage = "Error al procesar los datos";
          this.toastr.error('Error al procesar los datos', 'Error', { timeOut: 1500 });
          console.error('Error en saveSell:', error);
          this._cdr.detectChanges();
      }
    }

//#endregion


//#region updateHealthTechnologies

    updateHealthTechnologies(next: boolean): void
    {
        if (this.clinicHistory.healthTechnologies == null) {
            this.clinicHistory.healthTechnologies = new BOHealthTechnologies();
            this.clinicHistory.healthTechnologies.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnology = this.fourFormGroup.get('firstCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTecnologyFinality = this.fourFormGroup.get('secondCtrl')!.value;
        this.clinicHistory.healthTechnologies.prescriptionDate = this.fourFormGroup.get('threeCtrl').value != undefined ? new Date(this.fourFormGroup.get('threeCtrl').value) : null;
        this.clinicHistory.healthTechnologies.healthTecnologyMedicamentDescription = this.fourFormGroup.get('fourCtrl')!.value;
        if (this.clinicHistory.healthTechnologies.prescriptionMedicationDose == null) {
            this.clinicHistory.healthTechnologies.prescriptionMedicationDose = new BOPrescriptionMedicationDose();
            this.clinicHistory.healthTechnologies.prescriptionMedicationDose.id = 0;
        }
        this.clinicHistory.healthTechnologies.prescriptionMedicationDose.quantity = this.fourFormGroup.get('fifthCtrl')!.value;
        this.clinicHistory.healthTechnologies.prescriptionMedicationDose.measurementMedicationUnits = this.fourFormGroup.get('sixCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyVad = this.fourFormGroup.get('sevenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyTerm == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyTerm = new BOHealthTechnologyTerm();
            this.clinicHistory.healthTechnologies.healthTechnologyTerm.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyTerm.quantity = this.fourFormGroup.get('eightCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyTerm.timeUnit = this.fourFormGroup.get('nineCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyFrecuency == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyFrecuency = new BOHealthTechnologyFrecuency();
            this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.quantity = this.fourFormGroup.get('tenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyFrecuency.timeUnit = this.fourFormGroup.get('elevenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken = new BOHealthTechnologyMedicamentDoseTaken();
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.quantity = this.fourFormGroup.get('twelveCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseTaken.measurementMedicationUnits = this.fourFormGroup.get('thirteenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered == null) {
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered = new BOHealthTechnologyMedicamentDoseDelivered();
            this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.quantity = this.fourFormGroup.get('fiftheenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTechnologyMedicamentDoseDelivered.measurementMedicationUnits = this.fourFormGroup.get('sixteenCtrl')!.value;

        if (this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits == null) {
            this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits = new BOHealthTecnologyDeliveredUnits();
            this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.id = 0;
        }
        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.quantity = this.fourFormGroup.get('seventeenCtrl')!.value;
        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredUnits.measurementMedicationUnits = this.fourFormGroup.get('eighteenCtrl')!.value;

        this.clinicHistory.healthTechnologies.healthTecnologyDeliveredDate = this.fourFormGroup.get('fourteenCtrl').value != undefined ? new Date(this.fourFormGroup.get('fourteenCtrl').value) : null;

     this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString().trim()).subscribe(data =>
     {
            this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
                this.clinicHistory = data;
                //this.toastr.success('Historia Clinica Actualizada', 'Historia Clinica Actualizada Exitosamente');
                if (this.clinicHistory.healthTechnologiesResult != null)
                {
                    this.fifthFormGroup.patchValue({
                        firstCtrl: this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.diseaseCode,
                        secondCtrl: this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.orphanDisease,
                        threeCtrl: this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.diagnosticType,
                        fourCtrl: this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.diseaseCode,
                        fifthCtrl: this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.orphanDisease,
                        sixCtrl: this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.diseaseCode,
                        sevenCtrl: this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.orphanDisease,
                        eightCtrl: this.clinicHistory.healthTechnologiesResult.patientCondition,
                        nineCtrl: this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.diseaseCode,
                        tenCtrl: this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.orphanDisease,
                        elevenCtrl: this.clinicHistory.healthTechnologiesResult.medicalAttentionFinalizationDate,
                        thirteenCtrl: this.clinicHistory.healthTechnologiesResult.medicIncapacityType,
                        fourteenCtrl: this.clinicHistory.healthTechnologiesResult.medicIncapacityDays,
                        fiftheenCtrl: this.clinicHistory.healthTechnologiesResult.medicMaternityLicense
                    });
                    if (this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.diseaseCode != null) {
                        this.diseaseExitFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.diseaseCode);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.orphanDisease != null) {
                        this.orphanDiseaseExitFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.orphanDisease);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.diseaseCode != null) {
                        this.diseaseRelatedFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.diseaseCode);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.orphanDisease != null) {
                        this.orphanDiseaseRelatedFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.orphanDisease);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.diseaseCode != null) {
                        this.diseaseComplicationFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.diseaseCode);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.orphanDisease != null) {
                        this.orphanDiseaseComplicationFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.orphanDisease);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.diseaseCode != null) {
                        this.diseaseDeathFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.diseaseCode);
                    }
                    if (this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.orphanDisease != null) {
                        this.orphanDiseaseDeathFilterCtrl.setValue(this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.orphanDisease);
                    }
                }
                else {
                    this.fifthFormGroup.patchValue({
                        fourteenCtrl: 0,
                        fiftheenCtrl: 0
                    });
                }

                let allowed=["01","08","09", "37","38","44", "45", "47", "54"]; //
                 let passElement=false;

                 passElement=this.verifyServiceNumber(allowed);

                 if (!passElement)
                 {
                       this.close();
                 }

                 if (next) this.stepper.next();
                 else this.close();
            })

        });
    }
//#endregion

//#region updateHealthTechologiesResult


    updateHealthTechnologiesResult(next: boolean): void {
        if (this.clinicHistory.healthTechnologiesResult == null) {
            this.clinicHistory.healthTechnologiesResult = new BOHealthTechnologiesResult();
            this.clinicHistory.healthTechnologiesResult.id = 0;
        }

        if (this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic = new BOPrincipalMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('firstCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('secondCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic.diagnosticType = this.fifthFormGroup.get('threeCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic = new BORelatedMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('fourCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('fifthCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic = new BOComplicationMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('sixCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('sevenCtrl')!.value;

        this.clinicHistory.healthTechnologiesResult.patientCondition = this.fifthFormGroup.get('eightCtrl')!.value;

        if (this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic == null) {
            this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic = new BODeathMedicDiagnostic();
            this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.id = 0;
        }
        this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.diseaseCode = this.fifthFormGroup.get('nineCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic.orphanDisease = this.fifthFormGroup.get('tenCtrl')!.value;

        this.clinicHistory.healthTechnologiesResult.medicalAttentionFinalizationDate = this.fifthFormGroup.get('elevenCtrl').value != undefined ? new Date(this.fifthFormGroup.get('elevenCtrl').value) : null;
        this.clinicHistory.healthTechnologiesResult.medicIncapacityType = this.fifthFormGroup.get('thirteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicIncapacityDays = this.fifthFormGroup.get('fourteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicMaternityLicense = this.fifthFormGroup.get('fiftheenCtrl')!.value;

        this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString().trim()).subscribe(data => {
            this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
                this.clinicHistory = data;
                if (next) this.stepper.next();
                else this.close();
            })

        });
    }

    saveIncapacity()
    {
        this.clinicHistory.healthTechnologiesResult.medicIncapacityType = this.fifthFormGroup.get('thirteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicIncapacityDays = this.fifthFormGroup.get('fourteenCtrl')!.value;
        this.clinicHistory.healthTechnologiesResult.medicMaternityLicense = this.fifthFormGroup.get('fiftheenCtrl')!.value;

        this.busy = this._clinicHistoryService.updateClinicHistory(this.clinicHistory, this.stepper.selectedIndex.toString().trim()).subscribe(data => {
            this._clinicHistoryService.getClinicHistory(this.clinicHistory.id).subscribe(data => {
            this.clinicHistory = data;
            this.showSaveIncapacityBtn==true?this.showSaveIncapacityBtn=false:this.showSaveIncapacityBtn=true;

            })

        });




    }

    //#endregion


close(): void {
    this.modalSave.emit(null);
    this.modal.hide();
    this.stepper.reset();
    this.firstFormGroup.reset();
    this.secondFormGroup.reset();
    this.thirdFormGroup.reset();
    this.fourFormGroup.reset();

    this.patient = new BOPerson();
    this.patientInformation = new BOPatientInformation();
    this.clinicHistory = new BOClinicHistory();
    this.isSearchPatient = false;
    this.showOnlyObservations = false;
    this.submitted = false;
    this.stepperIndex = 0;
    this.panelOpenState = false;
        this.selectedCodeIcd10="";
        this.selectedGroupCodeIcd11="";
        this.isLoading = false;
        this.isSaving = false;
}

closeAndSaveHandle():void{

                    this.updateClinicHistory(false, this.stepper.selectedIndex.toString());
                    this.selectedCodeIcd10="";
                    this.selectedGroupCodeIcd11="";
                    this.isLoading = false;
                    this.isSaving = false;
                    this._cdr.detectChanges();
                    this.close();
}
//#region ObservationModal - - medicalFormula
    closeObservationModal(): void {
        var saveObservation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == this.tempObservation.id);
        var index = this.clinicHistory.clinicHistoryObservations.indexOf(saveObservation);
        this.clinicHistory.clinicHistoryObservations[index] = this.tempObservation;
        this.createOrEditModalObservation.hide();
    }
    // closeObservationModal():void
    // {
    //           this.createOrEditModalObservation.hide();
    //           this.tempObservation.observation="";

    // }
    closeFromHeaderObservationModal():void
    {
              this.clinicHistory.clinicHistoryObservations.pop();
              this.createOrEditModalObservation.hide();
    }



    openObservationModal(): void {
        this.tempObservationId--;
        this.clinicHistory.clinicHistoryObservations.push({ id: this.tempObservationId, observation: null });
        this.tempObservation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == this.tempObservationId);
        this.createOrEditModalObservation.config = { backdrop: "static", keyboard: false };
        this.createOrEditModalObservation.show();
    }

    openMedicalFormulaModal(): void {
        this.tempMedicalFormulaId--;
        var medicalFormula = new BOMedicalFormula();
        medicalFormula.id = this.tempMedicalFormulaId;

        this.createOrEditMedicalFormulaModal.openModal(this.healthTechnologyTimeUnitList, medicalFormula, true);
    }

    viewObservationModal(observationId: number): void {
        this.tempObservation = this.clinicHistory.clinicHistoryObservations.find(x => x.id == observationId);
        this.createOrEditModalObservation.config = { backdrop: "static", keyboard: false };
        this.createOrEditModalObservation.show();
    }

    deleteObservation(observationId: number): void {
        var deleteField = this.clinicHistory.clinicHistoryObservations.find(x => x.id == observationId);
        var index = this.clinicHistory.clinicHistoryObservations.indexOf(deleteField);
        if (index > -1) {
            this.clinicHistory.clinicHistoryObservations.splice(index, 1);
        }
    }

    deleteMedicalFormula(formulaId: number): void {
        var deleteField = this.clinicHistory.medicalFormula.find(x => x.id == formulaId);
        var index = this.clinicHistory.medicalFormula.indexOf(deleteField);
        if (index > -1) {
            this.clinicHistory.medicalFormula.splice(index, 1);
        }
    }
//#endregion ObservationModal - medicalFormula

//#region filters
    protected filterMedicineType() {
        if (!this.medicineTypeList) {
            return;
        }
        // get the search keyword
        let search = this.MedicineTypeFilterCtrl.value;
        if (!search) {
            this.filteredMedicineType.next(this.medicineTypeList.slice());
            return;
        } else {
            this.searchingMedicineType = true;
            this._medicineTypeService.getAll(search).subscribe(data => {
                this.medicineTypeList = data;
                this.filteredMedicineType.next(data);
                this.searchingMedicineType = false;
            }, error => {
                this.filteredMedicineType.next(this.medicineTypeList.slice());
                this.searchingMedicineType = false;
            });
        }
    }
    protected filterCountries() {
        if (!this.countries) {
            return;
        }
        // get the search keyword
        let search = this.countryFilterCtrl.value;
        if (!search) {
            this.filteredCountries.next(this.countries.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredCountries.next(
            this.countries.filter(country => country.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterOrphanDiseases() {
        if (!this.orphanDiseaseList) {
            return;
        }
        // get the search keyword
        let search = this.orphanDiseaseFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseases.next(this.orphanDiseaseList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseList = data;
                this.filteredOrphanDiseases.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseases.next(this.orphanDiseaseList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesRelated() {
        if (!this.orphanDiseaseRelatedList) {
            return;
        }
        // get the search keyword
        let search = this.orphanDiseaseRelatedFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesRelated.next(this.orphanDiseaseRelatedList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseRelatedList = data;
                this.filteredOrphanDiseasesRelated.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesRelated.next(this.orphanDiseaseRelatedList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesExit() {
        if (!this.orphanDiseaseExitList) {
            return;
        }
        // get the search keyword
        let search = this.orphanDiseaseExitFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesExit.next(this.orphanDiseaseExitList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseExitList = data;
                this.filteredOrphanDiseasesExit.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesExit.next(this.orphanDiseaseExitList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesComplication() {
        if (!this.orphanDiseaseComplicationList) {
            return;
        }
        // get the search keyword
        let search = this.orphanDiseaseComplicationFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesComplication.next(this.orphanDiseaseComplicationList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseComplicationList = data;
                this.filteredOrphanDiseasesComplication.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesComplication.next(this.orphanDiseaseComplicationList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterOrphanDiseasesDeath() {
        if (!this.orphanDiseaseDeathList) {
            return;
        }
        // get the search keyword
        let search = this.orphanDiseaseDeathFilterCtrl.value;
        if (!search) {
            this.filteredOrphanDiseasesDeath.next(this.orphanDiseaseDeathList.slice());
            return;
        } else {
            this.searchingOrphanDisease = true;
            this._orphanDiseaseService.getAll(search).subscribe(data => {
                this.orphanDiseaseDeathList = data;
                this.filteredOrphanDiseasesDeath.next(data);
                this.searchingOrphanDisease = false;
            }, error => {
                this.filteredOrphanDiseasesDeath.next(this.orphanDiseaseDeathList.slice());
                this.searchingOrphanDisease = false;
            });
        }
    }

    protected filterDiseases() {
        if (!this.diseaseList) {
            return;
        }
        // get the search keyword
        let search = this.diseaseFilterCtrl.value;
        if (!search) {
            this.filteredDiseases.next(this.diseaseList.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseList = data;
                this.filteredDiseases.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseases.next(this.diseaseList.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesRelated() {
        if (!this.diseaseListRelated) {
            return;
        }
        // get the search keyword
        let search = this.diseaseRelatedFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListRelated = data;
                this.filteredDiseasesRelated.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesRelated.next(this.diseaseListRelated.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesExit() {
        if (!this.diseaseListExit) {
            return;
        }
        // get the search keyword
        let search = this.diseaseExitFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesExit.next(this.diseaseListExit.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListExit = data;
                this.filteredDiseasesExit.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesExit.next(this.diseaseListExit.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesComplication() {
        if (!this.diseaseListComplication) {
            return;
        }
        // get the search keyword
        let search = this.diseaseComplicationFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListComplication = data;
                this.filteredDiseasesComplication.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesComplication.next(this.diseaseListComplication.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterDiseasesDeath() {
        if (!this.diseaseListDeath) {
            return;
        }
        // get the search keyword
        let search = this.diseaseDeathFilterCtrl.value;
        if (!search) {
            this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._diseaseService.getAll(search).subscribe(data => {
                this.diseaseListDeath = data;
                this.filteredDiseasesDeath.next(data);
                this.searchingDisease = false;
            }, error => {
                this.filteredDiseasesDeath.next(this.diseaseListDeath.slice());
                this.searchingDisease = false;
            });
        }
    }

    protected filterEps() {
        if (!this.epsList) {
            return;
        }
        // get the search keyword
        let search = this.epsFilterCtrl.value;
        if (!search) {
            this.filteredEps.next(this.epsList.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredEps.next(
            this.epsList.filter(eps => eps.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterOcupation() {
        if (!this.personOcupationList) {
            return;
        }
        // get the search keyword
        let search = this.ocupationFilterCtrl.value;
        if (!search) {
            this.filteredOcupation.next(this.personOcupationList.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredOcupation.next(
            this.personOcupationList.filter(ocupation => ocupation.description.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterIcd10ToIcd11() {
        if (!this.icd10ToIcd11List) {
            return;
        }
        // get the search keyword
        let search = this.icd10ToIcd11FilterCtrl.value;
        if (!search) {
            this.filteredIcd10ToIcd11.next(this.icd10ToIcd11List.slice());
            return;
        } else {
            this.searchingDisease = true;
            this._icd10ToIcd11Service.getAll(search).subscribe(data => {
                this.icd10ToIcd11List = data;
                this.filteredIcd10ToIcd11.next(data);
                this.searchingIcd10ToIcd11 = false;
            }, error => {
                this.filteredIcd10ToIcd11.next(this.icd10ToIcd11List.slice());
                this.searchingIcd10ToIcd11 = false;
            });
        }
    }
    //#endregion filters

protected filterCei11AgroupedUnified() {
  if (this.isModalMode) {
    // Modo modal: usa datos limitados
    this.filterCei11AgroupedModal();
  } else {
    // Modo normal: usa lista completa con búsqueda en servidor
    this.filterCei11Agrouped();
  }
}

protected filterCei11AgroupedModal(): void {
    if (!this.ceiAgroupedListShort || this.ceiAgroupedListShort.length === 0) {
        this.filteredCei11Agrouped.next([]);
        return;
    }

    const search = this.cei11AgroupedFilterCtrl.value;

    if (!search) {
        // Sin búsqueda: mostrar lista corta completa
        this.filteredCei11Agrouped.next(this.ceiAgroupedListShort.slice());
        return;
    }

    // Con búsqueda: filtrar localmente
    const searchLower = search.toLowerCase();
    const filtered = this.ceiAgroupedListShort.filter(group => {
        if (group.key.toLowerCase().includes(searchLower)) {
            return true;
        }
        return group.listCei10ToCei11.some(item =>
            item.codeIcd10.toLowerCase().includes(searchLower) ||
            (item.titleIcd10Spanish && item.titleIcd10Spanish.toLowerCase().includes(searchLower))
        );

    });

    this.filteredCei11Agrouped.next(filtered);
}
protected filterCei11Agrouped(): void {
    const search = this.cei11AgroupedFilterCtrl.value;

    if (!search) {
        // Sin búsqueda: mostrar lo que haya en memoria o vacío
        console.log("   Sin búsqueda");

        if (this.cei11AgroupedList && this.cei11AgroupedList.length > 0) {
            this.filteredCei11Agrouped.next(this.cei11AgroupedList.slice());
        } else {
            this.filteredCei11Agrouped.next([]);
        }
        return;
    }

    this.searchingCei11Agrouped = true;

    this._icd10ToIcd11Service.getCei11AgroupedByIcd11(search).subscribe(
        data => {
            // Guardar resultados
            this.cei11AgroupedList = data;

            // Emitir al ReplaySubject
            this.filteredCei11Agrouped.next(data);

            this.searchingCei11Agrouped = false;
        },
        error => {
            console.error("   ❌ Error:", error);
            this.filteredCei11Agrouped.next([]);
            this.searchingCei11Agrouped = false;
        }
    );
}


//#region onOptionSelect
    onOptionStateSelected(state: any)
    {
        if (state != null) {
            this.busy = this._cityService.getCitiesbyState(state).subscribe({
              next:(data) =>
              {
                if (state=='76')
                {
                  this.secondFormGroup.patchValue({
                    elevenCtrl:"76001"
                  })
                }
                this.cities = data;

              },
              error:(err)=>{

              }

            });
        }
    }

    onOptionDiagnosticPrincipal(code)
    {
      if(code=='01')
      {
        this.showDiagnosticPrincipal_ppal=true;
        this.showDiagnosticPrincipal_ppal_component=true;
        this.showDiagnosticPrincipal_orpha=false;
        this.showDiagnosticPrincipal_orpha_component=false;


        this._cdr.detectChanges();
      }

      else
      {
        this.showDiagnosticPrincipal_orpha=true;
        this.showDiagnosticPrincipal_orpha_component=true;
        this.showDiagnosticPrincipal_ppal=false;
        this.showDiagnosticPrincipal_ppal_component=false;
//    captura el value y asigna los valores de diag


        this._cdr.detectChanges();

      }

    }
    onOptionDiagnosticRelated(code)
    {
      if(code=='01')
      {
        this.showDiagnosticRelated_ppal=true;
        this.showDiagnosticRelated_ppal_component=true;
        this.showDiagnosticRelated_orpha=false;
        this.showDiagnosticRelated_orpha_component=true;

        this._cdr.detectChanges();
      }

      else
      {
        this.showDiagnosticRelated_orpha=true;
        this.showDiagnosticRelated_orpha_component=true;
        this.showDiagnosticRelated_ppal=false;
        this.showDiagnosticRelated_ppal_component=true;
//    captura el value y asigna los valores de diag


        this._cdr.detectChanges();

      }

    }


    onOptionAreaSelected(area: any)
    {
     if (area != null)
      {
          this.serviceGroupsListShort=[];
          this.profesionalsListShort =[];
          this.serviceGroupsListShort=Utilities.getGroupsByAreaId(area, this.serviceGroupsList);
          this.profesionalsListShort =Utilities.getProfessionalssByAreaId(area, this.profesionals);
      }
      else{
        this.toastr.error('Error','No se ha seleccionado un área');
      }
  }


  onOptionGroupSelected(groupId: any)
  {
    if (groupId != null)
      {
          this.serviceTypeListShort=[];
          this.serviceTypeListShort=Utilities.getServicesByGroupId(groupId, this.serviceTypeList);
      }
      else{
        this.toastr.error('Error','No se ha seleccionado un grupo');
      }
  }

  onOptionServiceTypeSelected(service: any)
  {
    let converted= parseInt(service);

    if(converted ==37)
    {
      this.isControl=true;
      this.thirdFormGroup.patchValue({
        fourteenCtrl: 0,
      });
    }
    else{
      this.isControl=false;
      this.thirdFormGroup.get('fourteenCtrl')?.enable();
    }

  }

  //#endregion onOptionSelect


  processMedicalFormula(medicalFormulaInput) {
        if (medicalFormulaInput != null)
        {
            if (medicalFormulaInput.id == 0)
            {
                this.tempMedicalFormulaId--;
                medicalFormulaInput.id = this.tempMedicalFormulaId;
            }
            this.clinicHistory.medicalFormula.push(medicalFormulaInput);
        }
  }

//#region print

  generatePDF() {
    this._patientInformationService.getPatientInformation(this.clinicHistory.patient.patientInformationId).subscribe({
        next:(data)=>{
          this.patientInformation=data;
          console.log("En GETDOCUMENTDEFINITION this.patientInformation es:", this.patientInformation);
  	    // AHORA sí construir y generar el PDF con los datos listos
        const docDefinition = this.getDocumentDefinition();
        pdfMake.createPdf(docDefinition).open();  // AHORA sí construir y generar el PDF con los datos listos

        },
        error:(err)=>
          {
          console.log("Error al obtener patientInformation");
        }
      })


  }
  getDocumentDefinition()
  {
       let dateTemp=this._datePipe.transform(this.clinicHistory.consultationDate, 'dd /MM/YYYY');
       let hourTemp = this._datePipe.transform(this.clinicHistory.consultationDate, 'HH:mm');
       //Incapacity
        const incapacityTypeCode = this.clinicHistory.healthTechnologiesResult.medicIncapacityType;
        const incapacityTypeName=incapacityTypeCode=='01'?'Prórroga':incapacityTypeCode=='02'?'Nueva':'No aplica';

       // const incapacityMaternityDays=this.clinicHistory.healthTechnologiesResult.medicMaternityLicense;

      const logoshort='data:image/png;base64,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';
        return {
          pageSize: 'A4',
          pageMargins: [10, 120, 20, 30],

          header:[
                //logo-dirección
                {
                  columns:
                  [
                    //logo
                    {
                      margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                    },
                    //blank space
                    {
                      fontSize:10,
                      text:
                      [
                        // {text:'Calle 5 Oeste Nª D-50-03\n' },
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'
                    },
                      // Dirección
                    {

                      fontSize:10,
                      text:
                      [
                        {text:'Calle 5 Oeste Nª D-50-03\n' },
                        {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                        {text:'Telf: 316 4071420\n' },
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'

                    },
                  ]
                },
                // company.nit
                {
                  fontSize: 10,
                  columns:
                  [
                      {
                          text: 'NIT '+ this.company.nit,
                          margin: [35, 0, 0, 0],
                          width: '50%'
                      }
                  ]
                },
                // company.email - pagina web

                {
                  fontSize: 10,
                  columns: [
                      {
                          text: this.company.email,
                          width: '40%',
                          margin: [35, 0, 0,0],
                          alignment: 'left',


                      },
                      {
                        text:'',
                        width: '5%',
                        margin: [15, 0, 0, 5],

                      },
                      {
                        text: 'www.servivitalcentromedico.com.co',
                        margin: [0, 0, -50, 5],
                          alignment: 'right',
                        width: '40%'
                    },


                  ]
              },

          ],



          content:
          [
            {
              margin: [20, 0, 20, 40],   // left, top, right, bottom
              stack:
              [

        //   #region title:
                {
                  columns:
                  [
                    {
                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'
                    },
                    {
                      fontSize:20,
                      text:
                      [
                        {text:'HISTORIA CLÍNICA' },

                      ],
                      margin: [25, 10, 15, 0],
                      alignment: 'center',
                      width: '60%'
                    },

                    {

                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'

                    },

                  ]
                },
                {
                  columns:
                  [
                    {
                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '5%'
                    },
                    {
                      fontSize:10,
                      text:
                      [
                        {text:'FECHA:',bold:true, }, dateTemp, {text:' HORA:',bold:true}, hourTemp,
                        {text:' -  HISTORIA CLÍNICA No.:',bold:true, }, this.clinicHistory.id

                      ],
                      margin: [25, 10, 15, 0],
                      alignment: 'center',
                      width: '90%'
                    },

                    {

                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '5%'

                    },

                  ]
                },
 //#endregion title: Historia Clínica

              //  space
                { text: ' ', margin: [0, 0, 0, 4] },

                { //obj2 DATOS PERSONALES -inicia la tabla
                      columns:
                      [
                        //First Column
                        {
                          fontSize: 10,
                          table:
                          {
                          // widths: [80,80,80,80,80,80],
                            widths: [80,80,80,80,80,80],

                            body:
                            [

                                [ //row 0 DATOS PERSONALES

                                {
                                  fontSize:15,
                                  alignment: 'center',

                                  colSpan: 6,
                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'DATOS PERSONALES', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row 1 Nombres-oApellidod
                                  //Nombres
                                  {
                                    colSpan:3,

                                    text:[
                                            {text:'NOMBRE(S):\n', bold:true},
                                            {text: this.patient.firstName+" " +this.patient.secondName}
                                        ]
                                  },
                                  {},{},
                                  //Primer apellido
                                  {

                                    colSpan:3,
                                    text:
                                        [
                                            {text:'APELLIDO(S):\n', bold:true},
                                            {text: this.patient.firtsSurName+" "+this.patient.secondSurName}
                                        ]
                                  },
                                  {},{},

                                ], //end row1

                                [ //row 2 FecHaNacimiento-Sexo-FechaIngreso
                                  //FECHA DE NACIMIENTO
                                  {
                                    //
                                    colSpan:2,
                                      text:[
                                        {text:'FECHA NACIMIENTO:\n', bold:true},
                                        {text: Utilities.convertDateToString(this.patient.birthDate)}
                                      ]

                                  },
                                  {},

                                  //EDAD
                                  {
                                      text:[
                                        {text:'EDAD (Años):\n', bold:true},
                                        {text: Utilities.calculateAge(this.patient.birthDate)}
                                      ]
                                  },
                                  //EDAD BEBE
                                  {
                                      text:[
                                        {text:'EDAD:(Meses):\n', bold:true},
                                        {text: Utilities.getBabyAgeAsString(this.patient.birthDate)}
                                      ]
                                  },
                                  //SEXO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'SEXO:\n', bold:true},
                                        {text:this.genderIdentityList.find(x => x.code == this.patientInformation.genderIdentity).name, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},


                                ], //end row2
                                [ //row 3 Tipo documento - No. Documento
                                  //Tipo documento
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'TIPO DOCUMENTO: \n', bold:true},
                                        {text:this.idTypeList.find(x => x.code == this.patient.idType).name, bold:true},{text:'\n'},
                                      ]

                                  },{},{},
                                  //EMAIL
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'NUMERO:\n', bold:true},
                                        {text: ''},{text: this.patient.personId}
                                      ]
                                  },{},{},

                                ], //end row3

                                [ //row 4 Dirección-Teléfono

                                  //DIRECCIÓN
                                  {
                                    colSpan:4,
                                      text:[
                                        {text:'DIRECCIÓN:\n', bold:true},
                                        {text: this.patient.address}
                                      ]
                                  }, {},{},{},
                                  //TELÉFONO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'No. TELÉFONO:\n', bold:true},
                                        {text: this.patient.cellPhoneNumber}
                                      ]
                                  },
                                  {},

                                ], //end row4

                                [ //row 5 EPS

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'EPS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.epsList.find(x => x.id == this.patientInformation.epsId).name, bold:true},{text:'\n'},

                                        ]

                                    },{},{},{},{},{},
                                ], //end row 5

                                [ //row 6 Contacto Emergencia-Parentesco-telefono
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'CONTACTO DE EMERGENCIA: \n', bold:true},
                                        {text:this.patient.emergencyContactName},
                                      ]

                                  },{},{},

                                  //TELÉFONO CONTACTO

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'TELÉFONO:\n', bold:true},
                                        {text:this.patient.emergencyContact},
                                      ]
                                  },{},{},

                                ], //end row6

                                [ //row Title: B.DATOS DEL PACIENTE

                                {
                                  colSpan: 6,
                                  fontSize:15,
                                  alignment: 'center',

                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'DATOS DEL PACIENTE', bold: true  }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row 8 sexo-identidad de género- categoría discapacidad

                                  //Sexo
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'SEXO:\n', bold:true},
                                         this.biologicalSexList.find(x => x.code == this.patientInformation.sexType)?.name
                                      ]
                                  }, {},
                                  //identidad de género
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'IDENTIDAD DE GÉNERO:\n', bold:true},
                                        this.genderIdentityList.find(x => x.code == this.patientInformation.genderIdentity)?.name,
                                      ]
                                  },
                                  {},
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'CATEGORÍA DISCAPACIDAD:\n', bold:true},
                                        this.disabilityCategoryList.find(x => x.code == this.patientInformation.disabilityCategory)?.name
                                        ]
                                  },
                                  {}

                                ], //end row8

                                [ //row Etnia- Comunidad étnica
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'ETNIA: \n', bold:true},
       //                                 this.ethnicCommunityList.find(x => x.code == this.patientInformation.ethnicCommunity)?.name,
                                        this.ethnicityList.find(x => x.code == this.patientInformation.ethnicity)?.name,

                                      ]

                                  },{},{},

                                  //TELÉFONO CONTACTO

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'COMUNIDAD ÉTNICA:\n', bold:true},
                                        //{text:this.patient.emergencyContact},
                                      ]
                                  },{},{},

                                ], //end row6

                                [ //row Zona Residencial- Pais nacionalidad
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'ZONA DE RESIDENCIA: \n', bold:true},
                                        this.residenceZoneList.find(x => x.code == this.patientInformation.residenceZone)?.name,
                                      ]

                                  },{},{},

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'PAÍS DE NACIONALIDAD:\n', bold:true},
                                         this.countries.find(x => x.id == this.patientInformation.birthCountryId)?.name,
                                      ]
                                  },{},{},

                                ], //end row6
                                [ //row País -Depto- Municipio

                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'PAÍS RESIDENCIA:\n', bold:true},
                                         this.countries.find(x => x.id == this.patientInformation.residenceCountryId)?.name,
                                        ]
                                  }, {},
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'DEPARTAMENTO:\n', bold:true},
                                        this.states.find(x => x.code == this.cities.find(ci => ci.id == this.patientInformation.residenceCityId)?.code.substring(0, 2))?.name,
                                      ]
                                  },
                                  {},
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'MUNICIPIO:\n', bold:true},
                                        this.cities.find(x => x.id == this.patientInformation.residenceCityId)?.name
                                      ]
                                  },
                                  {},


                                ], //end row9

                                [ //row Title: C.DATOS DE INGRESO

                                {
                                  colSpan: 6,
                                  fontSize:15,
                                  alignment: 'center',

                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'DATOS DE INGRESO', bold: true  }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row Fecha Atención - Prestador del Servicio
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'FECHA DE ATENCIÓN: \n', bold:true},
                                         this.datePipe.transform(this.clinicHistory.consultationDate, 'dd/MM/yyyy HH:mm'),
                                      ]

                                  },{},{},

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'PRESTADOR DEL SERVICIO:\n', bold:true},
                                         this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.name,

                                      ]
                                  },{},{},

                                ], //end row

                                [ //row Grupo de Servicio-Modalidad Tecnología Salud
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'GRUPO DE SERVICIOS: \n', bold:true},
                                         this.serviceGroupsList.find(x => x.code == this.clinicHistory.serviceGroups)?.name,
                                      ]

                                  },{},{},

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'MODALIDAD TECNOLOGÍA DE LA SALUD:\n', bold:true},
                                         this.ipsList.find(x => x.id == this.clinicHistory.ipsId)?.name,

                                      ]
                                  },{},{},

                                ], //end row

                                [ //row Lugar de Atención-Ruta de Entrada
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'LUGAR DE ATENCIÓN: \n', bold:true},
                                         this.placeOfAttentionList.find(x => x.code == this.clinicHistory.placeOfAttention)?.name,
                                      ]

                                  },{},{},

                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'RUTA DE ENTRADA:\n', bold:true},
                                         this.routeOfEntryList.find(x => x.code == this.clinicHistory.routeOfEntry)?.name,

                                      ]
                                  },{},{},

                                ], //end row
                                [ //row Causa de Atención

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'CAUSA DE LA ATENCIÓN:\n', bold:true},
                                          this.consultationCauseList.find(x => x.code == this.clinicHistory.consultationCause)?.name,
                                        ]

                                    },{},{},{},{},{},
                                ], //end row

                                [ //row Title: D.ANTECEDENTES FAMILIARES

                                {
                                  colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',

                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'ANTECEDENTES FAMILIARES:'+this.relativeDiseases.length, bold: true  }
                                    //{ text: 'REGISTROS:'+this.relativeDiseases.length, bold: true, alignment: 'right' }

                                  ]
                                  },
                                  {},{},{},{},{}
                                ], //end row

                                ...(this.relativeDiseases.length > 0 ? [
                                  [  // ← Fila de la tabla principal
                                    {  // ← Celda 1: ocupa 6 columnas
                                      colSpan: 6,
                                      table: {
                                        widths: [50, 450],
                                        body: [
                                          [
                                            { text: 'FAMILIAR', bold: true },
                                            { text: 'ENFERMEDAD', bold: true },
                                          ],
                                          ...this.relativeDiseases.map(rd => [
                                            this.relativeTypeList.find(x => x.code === rd.relativeType)?.name || rd.relativeType,
                                            rd.cei10Name
                                          ])
                                        ]
                                      },
                                      layout: 'noBorders'
                                    },
                                    {}, {}, {}, {}, {}  // ← ¡OBLIGATORIOS! Celdas 2-6 vacías por el colSpan:6
                                  ]  // ← Cierra fila
                                ] : []),  // ← Si no hay datos, no se agrega nada

                                [ //row Title: FACTORES DE RIESGO

                                {
                                    colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',

                                    fillColor: '#FFF',
                                    color: '#000',
                                    text:
                                    [
                                      {
                                        text: { text: 'FACTORES DE RIESGO:'+this.patientRiskFactorList.length, bold: true },
                                      },

                                    ]
                                },
                                {},{},{},{},{}
                                ], //end row


                                // Solo se incluye si hay registros en la lista
                                ...(this.patientRiskFactorList.length > 0 ? [
                                  [
                                    {
                                      colSpan: 6,
                                      table: {
                                        widths: [120, 380],
                                        body: [
                                          [
                                            { text: 'TIPO RIESGO', bold: true },
                                            { text: 'DETALLE', bold: true },
                                          ],
                                          ...this.patientRiskFactorList.map(rf => [

                                            rf.riskFactorName,
                                            rf.riskFactorDetail
                                          ])
                                        ]
                                      },
                                      layout: 'noBorders' // O 'lightHorizontalLines', según prefieras
                                    }
                                  ]
                                ] : []), // ← Si la condición es falsa, se agrega un array vacío (no se añade nada)






                                [ //row Title: E.ANTECEDENTES FARMACOLÓGICOS

                                {
                                    colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',

                                    fillColor: '#FFF',
                                    color: '#000',
                                    text:
                                    [
                                      {
                                        text: { text: 'ANTECEDENTES FARMACOLÓGICOS:'+this.patientFarmacologicRecordsList.length, bold: true },
                                      },

                                    ]
                                },
                                {},{},{},{},{}
                                ], //end row


                                // Solo se incluye si hay registros en la lista
                                ...(this.patientFarmacologicRecordsList.length > 0 ? [
                                  [
                                    {
                                      colSpan: 6,
                                      table: {
                                        widths: [50, 380, 70],
                                        body: [
                                          [
                                            { text: 'CÓDIGO', bold: true },
                                            { text: 'MEDICAMENTO', bold: true },
                                            { text: 'HABILITADO', bold: true },
                                          ],
                                          ...this.patientFarmacologicRecordsList.map(fr => [
                                            fr.code,
                                            fr.name,
                                            fr.enabled ? 'SI' : 'NO'
                                          ])
                                        ]
                                      },
                                      layout: 'noBorders' // O 'lightHorizontalLines', según prefieras
                                    }
                                  ]
                                ] : []), // ← Si la condición es falsa, se agrega un array vacío (no se añade nada)


                                [ //row Title: F.ALERGIAS DEL PACIENTE

                                {
                                    colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',
                                    fillColor: '#FFF',
                                    color: '#000',
                                    text: [
                                      {
                                        text: { text: 'ALERGIAS DEL PACIENTE:'+this.patientAllergiesList.length, bold: true },
                                      },

                                    ]
                                },
                                {},{},{},{},{}
                                ], //end row

                                ...(this.patientAllergiesList.length > 0 ? [
                                  [  // ← Fila de la tabla principal
                                    {  // ← Celda 1: ocupa 6 columnas
                                      colSpan: 6,
                                      table: {
                                        widths: [150, 350],
                                        body: [
                                          [
                                            { text: 'TIPO DE ALERGIA', bold: true },
                                            { text: 'ALÉRGENO', bold: true },
                                          ],
                                          ...this.patientAllergiesList.map(al => [
                                                  al.allergyName,
                                                  al.allergen
                                          ])
                                        ]
                                      },
                                      layout: 'noBorders'
      //                                      layout: {
      //   hLineWidth: function(i, node) { return 1; },
      //   vLineWidth: function(i, node) { return 1; },
      //   hLineColor: function(i, node) { return '#808080'; },
      //   vLineColor: function(i, node) { return '#808080'; },
      //   paddingLeft: function(i, node) { return 4; },
      //   paddingRight: function(i, node) { return 4; },
      //   paddingTop: function(i, node) { return 2; },
      //   paddingBottom: function(i, node) { return 2; }
      // }
                                     },
                                    {}, {}, {}, {}, {}  // ← ¡OBLIGATORIOS! Celdas 2-6 vacías por el colSpan:6
                                  ]  // ← Cierra fila
                                ] : []),  // ← Si no hay datos, no se agrega nada


                                [ //row Title: H.INCAPACIDAD

                                {
                                  colSpan: 6,
                                  fontSize:15,
                                  alignment: 'center',

                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'INCAPACIDAD', bold: true  }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1
                                [ //row Tipo icapacidad- Dias Incapacidad- Días Incapacidad Maternidad

                                  //Tipo Incapacidad
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'TIPO INCAPACIDAD:\n', bold:true},
                                        incapacityTypeName
                                       // {text:this.clinicHistory.healthTechnologiesResult.medicIncapacityType+ '\n', bold:true},


                                  //      incapacityTypeName
                                      ]
                                  }, {},
                                   //Días Incapacidad
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'DÍAS DE INCAPACIDAD:\n', bold:true},
                                        {text:this.clinicHistory.healthTechnologiesResult.medicIncapacityDays+ '\n', bold:true},
                                       // incapacityDays
                                      ]
                                  },
                                  //Dias Incapacidad Maternidad
                                  {},
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'DÍAS DE INCAPACIDAD POR MATERNIDAD:\n', bold:true},
                                        {text:this.clinicHistory.healthTechnologiesResult.medicMaternityLicense + '\n', bold:true},
//                                        {text:'DÍAS INCAPACIDAD POR MATERNIDAD:'+incapacityMaternityDays+ '\n', bold:true},

                                      ]
                                  },
                                  {}

                                ], //end row8

                            ], //table end body
                          }
                        }, //Obj2.columns.First Column End columns

                      ] //obj 2 end Columns

                }, //End obj2

              //Separador
           // { text: ' ', margin: [0, 10, 0, 10] },
//------ SALTO DE PÁGINA 2
               { text: '', pageBreak: 'after' },

               {
                      columns:
                      [
                        //First Column
                        {
                          fontSize: 10,
                          table:
                          {
                          // widths: [80,80,80,80,80,80],
                            widths: [80,80,80,80,80,80],

                            body:
                            [

/////////
                                [ //row Title: DIAGNÓSTICO PRINCIPAL

                                {
                                    colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',

                                    fillColor: '#FFF',
                                    color: '#000',
                                    text:
                                    [
                                      {
                                        text: { text: 'DIAGNÓSTICO PRINCIPAL:', bold: true },
                                      },

                                    ]
                                },
                                {},{},{},{},{}
                                ], //end row


                                // Solo se incluye si hay registros en la lista
                                ...(this.patientDiagnosticPrincipalList.length > 0 ? [
                                  [
                                    {
                                      colSpan: 6,
                                      table: {
                                        widths: [100, 65, 365],
                                        body:
                                        [
                                          [
                                            { text: 'TIPO ENF.', bold: true },
                                            { text: 'COD.CIE 10', bold: true },
                                            { text: 'ENFERMEDAD', bold: true },

                                          ],

                                      ...this.patientDiagnosticPrincipalList.flatMap(dp => [
                                        [
                                          { text: dp.diseaseType==1?"Común":"Huérfana" },
                                          { text: dp.cie10Code },
                                          { text: dp.cie10Name, noWrap: false, margin: [0, 3, 0, 3]}
                                        ],

                                        [
                                          {
                                            colSpan: 3,
                                            margin: [1, 5, 0, 10],
                                            text: [
                                              { text: 'DETALLES:\n', bold: true },
                                              { text: dp.details || '' }
                                            ]
                                          },
                                          {},
                                          {}
                                        ]
                                      ])
                                        ]},
                                      layout: 'noBorders' // O 'lightHorizontalLines', según prefieras
                                    }
                                  ]
                                ] : []), // ← Si la condición es falsa, se agrega un array vacío (no se añade nada)

///
                                [ //row Title: DIAGNÓSTICO PRINCIPAL

                                {
                                    colSpan: 6,
                                    fontSize:15,
                                    alignment: 'center',

                                    fillColor: '#FFF',
                                    color: '#000',
                                    text:
                                    [
                                      {
                                        text: { text: 'DIAGNÓSTICOS RELACIONADOS:', bold: true },
                                      },

                                    ]
                                },
                                {},{},{},{},{}
                                ], //end row


                                // Solo se incluye si hay registros en la lista
                                ...(this.patientDiagnosticRelatedList.length > 0 ? [
                                  [
                                    {
                                      colSpan: 6,
                                      table: {
                                        widths: [100, 65, 365],
                                        body:
                                        [
                                          [
                                            { text: 'TIPO ENF.', bold: true },
                                            { text: 'CODIGO', bold: true },
                                            { text: 'ENFERMEDAD', bold: true },

                                          ],

                                      ...this.patientDiagnosticRelatedList.flatMap(dp => [
                                        [
                                          { text: dp.diseaseType==1?"Común":"Huérfana" },
                                          { text: dp.orphanDiseaseCode },
                                          { text: dp.orphanDiseaseName, noWrap: false, margin: [0, 3, 0, 3]}
                                        ],

                                        [
                                          {
                                            colSpan: 3,
                                            margin: [1, 5, 0, 10],
                                            text: [
                                              { text: 'DETALLES:\n', bold: true },
                                              { text: dp.details || '' }
                                            ]
                                          },
                                          {},
                                          {}
                                        ]
                                      ])
                                        ]},
                                      layout: 'noBorders' // O 'lightHorizontalLines', según prefieras
                                    }
                                  ]
                                ] : []), // ← Si la condición es falsa, se agrega un array vacío


///
                                [ //row I.Detalles Historia Clínica

                                {
                                  colSpan: 6,
                                  fontSize:15,
                                  alignment: 'center',

                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'DETALLES HISTORIA CLÍNICA', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

///////////
                                [ //row  Antecdentes Patológicos y familiares

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'ANTECEDENTES PATOLÓGICOS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                          this.clinicHistory.pathologicalRecord
                                        ]

                                    },{},{},{},{},{},
                                ], //end row 5
                                [ //row  Motivo de consulta

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'MOTIVO DE CONSULTA:\n', bold:true},
                                         //  this.clinicHistory.consultationCause
                                          this.consultationCauseList.find(x => x.code == this.clinicHistory.consultationCause)?.name,
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Anamnesis

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'ANAMNESIS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.anamnesis
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Impresión de Diagnóstico

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'IMPRESIÓN DE DIAGNÓSTICO:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.diagnosticImpression
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Control de Laboratorio

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'CONTROL DE LABORATORIO:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.diagnosticImpression
                                        ]

                                    },{},{},{},{},{},
                                ], //end row


                                [ //row  Plan de Tratamiento

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'PLAN DE TRATAMIENTO:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.treatmentPlan
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row Title: J.EXAMEN FÍSICO

                                {
                                  colSpan: 6,
                                  fontSize:15,
                                  alignment: 'center',
                                  fillColor: '#FFF', // Color azul
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'EXAMEN FÍSICO', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1
                                [ //row Presión Arterial-Temperatura- pulso
                                  //Presión Arterial
                                  {
                                    //
                                    colSpan:2,
                                      text:[
                                        {text:'PRESIÓN ARTERIAL:\n', bold:true},
                                        this.clinicHistory.arterialPressure
                                      ]

                                  },
                                  {},

                                  //TEMPERATURA
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'TEMPERATURA:\n', bold:true},
                                        this.clinicHistory.temperature
                                      ]
                                  },
                                  {},
                                  //PULSO
                                  {
                                    colSpan:2,

                                      text:[
                                        {text:'PULSO:\n', bold:true},
                                        this.clinicHistory.pulse
                                      ]
                                  },
                                  {},
                                ], //end row2
                                [ //row Peso- Talla - Organos
                                  //Presión Arterial
                                  {
                                    //
                                    colSpan:2,
                                      text:[
                                        {text:'PESO:\n', bold:true},
                                        this.clinicHistory.weight
                                      ]

                                  },
                                  {},

                                  //TALLA
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'TALLA:\n', bold:true},
                                        this.clinicHistory.size
                                      ]
                                  },
                                  {},
                                  //RESPIRACIÓN
                                  {
                                    colSpan:2,

                                      text:[
                                        {text:'RESPIRACIÓN:\n', bold:true},
                                        this.clinicHistory.breathing
                                      ]
                                  },
                                  {},
                                ], //end

                                [ //row Title: órganos

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'H.ÓRGANOS', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row  Cabeza

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'CABEZA:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.head
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Cuello

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'CUELLO:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.neck
                                        ]

                                    },{},{},{},{},{},
                                ], //end row

                                [ //row  tóraz

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'TÓRAX:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.chest
                                        ]

                                    },{},{},{},{},{},
                                ], //end row


                                [ //row  abdomen

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'ABDOMEN:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.belly
                                        ]

                                    },{},{},{},{},{},
                                ], //end row

                                [ //row  pelvis

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'PELVIS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.pelvis
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Extremidades

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'EXTREMIDADES:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.extremities
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Piel

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'PIEL:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.skin
                                        ]

                                    },{},{},{},{},{},
                                ], //end row
                                [ //row  Sistema Nervioso Central

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'SISTEMA NERVIOSO CENTRAL:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                           this.clinicHistory.centralNervousSystem
                                        ]

                                    },{},{},{},{},{},
                                ], //end row

                            ], //table end body
                          }
                        }, //Obj2.columns.First Column End columns

                      ] //obj 2 end Columns

               }, //end obj3
//------ SALTO DE PÁGINA 2

               { text: '', pageBreak: 'after' },

               {
                  columns:
                  [
                    // First Column
                    {
                      fontSize: 10,
                      table:
                      {
                        widths: [80, 80, 80, 80, 80, 80],

                        body:
                        [

                          /////////////////////////////////////////////////////////////////
                          // TÍTULO
                          /////////////////////////////////////////////////////////////////
                          [
                            {
                              colSpan: 6,
                              fontSize: 15,
                              alignment: 'center',
                              fillColor: '#FFF',
                              color: '#000',
                              text: [
                                {
                                  text:
                                  {
                                    text: 'NÚMERO DE CONTROLES A LA FECHA: ' + this.chControlList.length,
                                    bold: true
                                  }
                                }
                              ]
                            },
                            {},
                            {},
                            {},
                            {},
                            {}
                          ],

                          /////////////////////////////////////////////////////////////////
                          // CONTROLES
                          /////////////////////////////////////////////////////////////////
                          ...(this.chControlList.length > 0
                            ? this.chControlList.map(ctrl => [

                                {
                                  colSpan: 6,
                                  margin: [0, 8, 0, 8],

                                  table:
                                  {
                                    widths: [100, 110, 300],

                                    body:
                                    [

                                      /////////////////////////////////////////////////////
                                      // Encabezados
                                      /////////////////////////////////////////////////////
                                      [
                                        {
                                          text: 'CONTROL No.',
                                          bold: true,
                                          fillColor: '#EDEDED'
                                        },
                                        {
                                          text: 'FECHA',
                                          bold: true,
                                          fillColor: '#EDEDED'
                                        },
                                        {
                                          text: 'PROFESIONAL',
                                          bold: true,
                                          fillColor: '#EDEDED'
                                        }
                                      ],

                                      /////////////////////////////////////////////////////
                                      // Datos
                                      /////////////////////////////////////////////////////
                                      [
                                        {
                                          text: ctrl.controlNumber ?? ''
                                        },
                                        {

                                     //     text: ctrl.controlDate ?? ''
                                          text: this.datePipe.transform(ctrl.controlDate, 'dd/MM/yyyy HH:mm') ?? ''

                                        },
                                        {
                                          //text: ctrl.professionalId ?? ''
                                          //FALLIDO:text:Utilities.getNameFromPerson(ctrl.profesional)?? 'NO FOUND'
                                          text:[
                                            {
                                              text:Utilities.getProfesionalName(ctrl.professionalId, this.profesionalsListShort)?? 'NO FOUND'
                                            }
                                          ]
                                        }
                                      ],

                                      /////////////////////////////////////////////////////
                                      // Detalles (Título)
                                      /////////////////////////////////////////////////////
                                      [
                                        {
                                          colSpan: 3,
                                          margin: [0, 8, 0, 3],
                                          text: 'DETALLES',
                                          bold: true
                                        },
                                        {},
                                        {}
                                      ],

                                      /////////////////////////////////////////////////////
                                      // Detalles (Contenido)
                                      /////////////////////////////////////////////////////
                                      [
                                        {
                                          colSpan: 3,
                                          margin: [0, 0, 0, 8],
                                          text: ctrl.details || ''
                                        },
                                        {},
                                        {}
                                      ]

                                    ]},

                                  layout: 'noBorders'
                                  // {
                                  //   // hLineWidth: function () { return 0.5; },
                                  //   // vLineWidth: function () { return 0.5; },
                                  //   // hLineColor: function () { return '#BDBDBD'; },
                                  //   // vLineColor: function () { return '#BDBDBD'; },
                                  //   paddingLeft: function () { return 5; },
                                  //   paddingRight: function () { return 5; },
                                  //   paddingTop: function () { return 4; },
                                  //   paddingBottom: function () { return 4; }
                                  // }

                                },

                                {},
                                {},
                                {},
                                {},
                                {}

                              ])
                            : [])

                        ] // end body
                      }
                    }

                  ] // end columns
               }

////////////
          ] }
          ],

          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableExample: {
              margin: [0, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
          }
        }




////////////







  }



  getGeneralDiagnosticReport() {
        if (this.clinicHistory.healthTechnologies != null) {
            return [
                {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 10],
                    alignment: 'center',
                    pageBreak: "before",
                    text: 'Diagnostico General',
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Antecedentes Patologicos: ', bold: true }, this.clinicHistory.pathologicalRecord],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Motivo de Consulta: ', bold: true }, this.clinicHistory.consultationMotive],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Anamnesis: ', bold: true }, this.clinicHistory.anamnesis],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Impresión Diagnostica: ', bold: true }, this.clinicHistory.diagnosticImpression],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Contol de Laboratorio: ', bold: true }, this.clinicHistory.laboratoryControl],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Plan de Tratamiento: ', bold: true }, this.clinicHistory.treatmentPlan],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Examen Fisico',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Presion Arterial: ', bold: true }, this.clinicHistory.arterialPressure],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Temperatura: ', bold: true }, this.clinicHistory.temperature],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Pulso: ', bold: true }, this.clinicHistory.pulse],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Peso: ', bold: true }, this.clinicHistory.weight],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Talla: ', bold: true }, this.clinicHistory.size],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Respiración: ', bold: true }, this.clinicHistory.breathing],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Organos',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Cabeza: ', bold: true }, this.clinicHistory.head],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Cuello: ', bold: true }, this.clinicHistory.neck],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Torax: ', bold: true }, this.clinicHistory.chest],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Abdomen: ', bold: true }, this.clinicHistory.belly],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Pelvis: ', bold: true }, this.clinicHistory.pelvis],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Extremidades: ', bold: true }, this.clinicHistory.extremities],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Piel: ', bold: true }, this.clinicHistory.skin],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Sistema Nervioso Central: ', bold: true }, this.clinicHistory.centralNervousSystem],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
            ]
        }
        else return "";
    }

    getHealthTecnologiesForReport() {
        if (this.clinicHistory.healthTechnologies != null) {
            return [
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Tecnologias de la Salud',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Tecnologia de la Salud: ', bold: true }, this.healthTechnologyList.find(x => x.code == this.clinicHistory.healthTechnologies.healthTechnology)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Finalidad de la Tecnologia de la Salud: ', bold: true }, this.healthTechnologyFinalityList.find(x => x.code == this.clinicHistory.healthTechnologies.healthTecnologyFinality)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Prescripción: ', bold: true }, this.datePipe.transform(this.clinicHistory.healthTechnologies.prescriptionDate, 'dd/MM/yyyy HH:mm')],
                            margin: [0, 10, 0, 0],
                            width: '100%'
                        }
                    ]
                },
            ]
        }
        else return "";
    }

    getHealthTecnologiesResultForReport() {
        if (this.clinicHistory.healthTechnologiesResult != null) {
            return [
                {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    text: 'Resultado Tecnologias de la Salud',
                },
                {
                    canvas: [
                        { type: 'line', x1: 0, y1: 0, x2: 595 - 300, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Egreso: ', bold: true }, this.diseaseListExit.find(x => x.code == this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseExitList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.principalMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Relacionado: ', bold: true }, this.diseaseListRelated.find(x => x.code == this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseRelatedList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.relatedMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Complicación: ', bold: true }, this.diseaseListComplication.find(x => x.code == this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseComplicationList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.complicationMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Condicion de Egreso: ', bold: true }, this.patientConditionList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.patientCondition)?.name],
                            margin: [0, 5, 0, 0],
                            width: '100%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Diagnostico Muerte: ', bold: true }, this.diseaseListDeath.find(x => x.code == this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.diseaseCode)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Enfermedad Huerfana: ', bold: true }, this.orphanDiseaseDeathList.find(x => x.code == this.clinicHistory.healthTechnologiesResult.deathMedicDiagnostic?.orphanDisease)?.name],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Egreso: ', bold: true }, this.datePipe.transform(this.clinicHistory.healthTechnologiesResult.medicalAttentionFinalizationDate, 'dd/MM/yyyy HH:mm')],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Tipo de Incapacidad: ', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Dias de Incapacidad: ', bold: true }, this.clinicHistory.healthTechnologiesResult.medicIncapacityDays.toString()],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Dias de LMA: ', bold: true }, this.clinicHistory.healthTechnologiesResult.medicMaternityLicense.toString()],
                            margin: [0, 5, 0, 0],
                            width: '50%'
                        }
                    ]
                },
            ]
        }
        else return "";
    }

    getMedicalFormulaForReport() {
        if (this.clinicHistory.medicalFormula.length > 0) {
            /*this.clinicHistory.medicalFormula.forEach(x => {
                x.doseDescription = x.dose.toString() + " " + x.doseType;
                x.doseFrecuencyQuantityDescription = x.doseFrecuencyQuantity.toString() + " " + this.healthTechnologyTimeUnitList.find(h => h.code == x.doseFrecuency).name;
                x.doseDurationDescription = x.doseDurationQuantity.toString() + " " + this.healthTechnologyTimeUnitList.find(h => h.code == x.doseDuration).name;
            });*/
            return [
                {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 4],
                    alignment: 'center',
                    pageBreak: "before",
                    text: 'FÓRMULA MÉDICA',
                },
                //ric
                {
                    columns: [
                        {
                            fontSize: 12,
                            text: [{ text: 'Fecha: ', bold: true }, this.datePipe.transform(this.clinicHistory.consultationDate, 'dd/MM/yyyy')],
                            margin: [0, 4, 0, 10],
                            alignment: 'center',
                            width: '100%'
                        },
                    ]
                },
                //
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Información del Paciente', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Profesional de la Salud', bold: true }, ""],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    canvas: [
                        { type: 'line', x1: 10, y1: 0, x2: 595 - 10, y2: 0, lineWidth: 0.5 }
                    ]

                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Nombre: ', bold: true }, this.patient.firstName + " " + this.patient.secondName + " " + this.patient.firtsSurName + " " + this.patient.secondSurName],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Nombre: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.firstName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.secondName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.firtsSurName + " " + this.profesionals.find(x=> x.id == this.profesionalSelected)?.secondSurName],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Tipo de Documento: ', bold: true }, this.idTypeList.find(x => x.code == this.patient.idType).name],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Numero de Registro: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.registerNumber],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'No.: ', bold: true }, this.patient.personId],
                            margin: [0, 5, 0, 0],
                            width: '55%'
                        },
                        {
                            fontSize: 10,
                            text: [{ text: 'Rethus: ', bold: true }, this.profesionals.find(x=> x.id == this.profesionalSelected)?.rethus],
                            margin: [0, 5, 0, 0],
                            width: '45%'
                        }
                    ]
                },
                {
                    columns: [
                        {
                            fontSize: 10,
                            text: [{ text: 'Fecha de Nacimiento: ', bold: true }, this.datePipe.transform(this.patient.birthDate, 'dd/MM/yyyy')],
                            margin: [0, 5, 0, 10],
                            width: '70%'
                        }
                    ]
                },
                {
                    table: {
                        widths: ['20%', '15%', '20%', '45%'],
                        body: [
                            [{
                                text: 'Medicamento',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Presentación',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Concentración',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Descripción',
                                style: 'tableHeader'
                            }
                            ],
                            ...this.clinicHistory.medicalFormula.map(ed => {
                            return [ed.medicationName, ed.presentation, ed.concentration, ed.doseDescription + " " + ed.doseFrecuency  + ", " + ed.indications+". Total:" + ed.doseDuration];

                              //  return [ed.medicationName, ed.presentation, ed.concentration, ed.doseDescription + " " + ed.doseFrecuency + " " + ed.doseDuration + ", " + ed.indications];
                            })
                        ]
                    }
                }
            ]
        }
        else return "";
    }

    getObservationsForReport() {
        if (this.clinicHistory.clinicHistoryObservations.length > 0) {
            return [
                {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 10],
                    alignment: 'center',
                    pageBreak: "before",
                    text: 'Observaciones',
                },
                {
                    table: {
                        widths: ['75%', '25%'],
                        body: [
                            [{
                                text: 'Observación',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Fecha',
                                style: 'tableHeader'
                            },
                            ],
                            ...this.clinicHistory.clinicHistoryObservations.map(ed => {
                                return [ed.observation, this.datePipe.transform(ed.creationDate, 'dd/MM/yyyy HH:mm')];
                            })
                        ]
                    }
                }
            ]
        }
        else return "";
    }

    //#endregion print


    ngOnDestroy(): void {
        this.busy?.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    formValid(): boolean {
        switch (this.stepper.selectedIndex) {
            case 0:
                return this.firstFormGroup.valid;
            case 1:
                return this.secondFormGroup.valid;
            case 2:
                return this.thirdFormGroup.valid;
            case 3:
                return this.fourFormGroup.valid;
            case 4:
                return this.fifthFormGroup.valid;
            case 5:
                return this.sixFormGroup.valid && this.destinationPatientFormGroup.valid;
            case 6:
                return true;
            case 7:
                return true;
        }

    }

    next(next: boolean): void {
        if (this.showOnlyObservations)
        {
          this.updateClinicHistory(next,"7");
        }
        else {
            switch (this.stepper.selectedIndex) {
                case 0:
                    this.createOrUpdatePerson(next);
                    break;
                case 1:
                    this.createOrUpdatePatientInformation(next);
                    break;
                case 2:
                    this.updateClinicHistory(next,"2");
                    break;
                case 3:
                    this.updateHealthTechnologies(next);
                    break;
                case 4:
                    this.updateHealthTechnologiesResult(next);
                    break;
                case 5:
                    this.updateClinicHistory(next,"5");
                    break;
                case 6:
                    this.updateClinicHistory(next,"6");

                    break;
                case 7:
                     this.updateClinicHistory(next,"7");
                     //this.isSaveAndClose=true;
                     this.close();
                    break;
            }
        }
        this.panelOpenState = false;
    }

    previous(): void {
        this.stepper.previous();
        this.panelOpenState = false;
    }

    verifyServiceNumber(data:string[]):boolean
    {
        let result:boolean=false;
          if (data.includes(this.clinicHistory.serviceType)) result=true;

        return result;
    }

    getNameFromClinichistory():string
    {
     let result='';
      let sname=this.clinicHistory.patient.secondName;
      let sn='';
      sname.length>0?sn=sname:sn='';
      let name=this.clinicHistory.patient.firstName +' '+sn;

      let ssname= this.clinicHistory.patient.secondSurName;
      let secondsn='';
      ssname.length>0?secondsn=ssname: secondsn='';
      let lastname=this.clinicHistory.patient.firtsSurName +' '+secondsn;
      result= name+' '+lastname;


      return result;
    }
//#region clipboard
    copyToClipboardAll(): void {
      // Obtener los valores del formulario
      const firstN = this.firstFormGroup.get('firstCtrl')?.value;
      const secondN = this.firstFormGroup.get('secondCtrl')?.value;
      const firstS = this.firstFormGroup.get('threeCtrl')?.value;
      const secondS = this.firstFormGroup.get('fourCtrl')?.value;
      const userName=Utilities.getNameFromPersonByData(firstN, secondN, firstS,secondS)
      const userDocumentId= this.firstFormGroup.get('sixCtrl')?.value;
      const userEmail= this.firstFormGroup.get('sevenCtrl')?.value;
      const userAddress= this.firstFormGroup.get('nineCtrl')?.value;


      // Crear el contenido para copiar al portapapeles
      const clipboardContent = `${userName}\n ${userDocumentId}\n ${userEmail}\n ${userAddress}`;

      // Usar la API del navegador para copiar al portapapeles
      navigator.clipboard.writeText(clipboardContent).then(() => {

      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardName(): void {
      // Obtener los valores del formulario
      const firstN = this.firstFormGroup.get('firstCtrl')?.value;
      const secondN = this.firstFormGroup.get('secondCtrl')?.value;
      const firstS = this.firstFormGroup.get('threeCtrl')?.value;
      const secondS = this.firstFormGroup.get('fourCtrl')?.value;
      const userName=Utilities.getNameFromPersonByData(firstN, secondN, firstS,secondS)

      // Crear el contenido para copiar al portapapeles
      const clipboardContent = `${userName}`;

      // Usar la API del navegador para copiar al portapapeles
      navigator.clipboard.writeText(clipboardContent).then(() => {

      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardDocument(): void {
      // Obtener los valores del formulario
      const userDocumentId= this.firstFormGroup.get('sixCtrl')?.value;
     // const userEmail= this.firstFormGroup.get('sevenCtrl')?.value;


      // Crear el contenido para copiar al portapapeles
      const clipboardContent =`${userDocumentId}`;

      // Usar la API del navegador para copiar al portapapeles
      navigator.clipboard.writeText(clipboardContent).then(() => {

      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardEmail(): void {
      // Obtener los valores del formulario
      const userEmail= this.firstFormGroup.get('sevenCtrl')?.value;
      // Crear el contenido para copiar al portapapeles
      const clipboardContent =`${userEmail}`;

      // Usar la API del navegador para copiar al portapapeles
      navigator.clipboard.writeText(clipboardContent).then(() => {

      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

    copyToClipboardAddress(): void {
      // Obtener los valores del formulario
      const userAddress= this.firstFormGroup.get('nineCtrl')?.value;
      // Crear el contenido para copiar al portapapeles
      const clipboardContent =`${userAddress}`;

      // Usar la API del navegador para copiar al portapapeles
      navigator.clipboard.writeText(clipboardContent).then(() => {

      }).catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
    }

//#endregion clipboard



  openCreateReport(clinicHistoryId)
  {
    this.getSellByClinicHistoryId(clinicHistoryId);
  }

  getSellByClinicHistoryId(clinicHistoryId:number)
  {
    this._sellService.getSellByClinicHistoryId(clinicHistoryId).subscribe(data=>{

      this.clinicHistoryAsignedToSell=data.clinicHistoryId;
      this._cdr.detectChanges();
     this.stepper.linear = false; // Desactiva el modo lineal
     this.showOnlyObservations=false;
     this._cdr.detectChanges();
     this.stepper.selectedIndex=6;
     this.stepper.linear = true; // Reactiva el modo lineal si es necesario
     })
  }

  goToDiagnostic(clinicHistoryId:number)
  {
    console.log("ENTRA A GOTODIAGNOSTIC, this.clinicHistory es:", this.clinicHistory);
     this.stepper.linear = false; // Desactiva el modo lineal
     this.showOnlyObservations=false;
     this._cdr.detectChanges();
     this.stepper.selectedIndex=6;
     this.stepper.linear = true; // Reactiva el modo lineal si es necesario

     this._clinicHistoryService.getClinicHistory(clinicHistoryId).subscribe({
      next:(data)=>{
        console.log("en GODIAGNOSTIC SERVICE, this.clinicHistory es:", this.clinicHistory);
        const ch=data;
                this.sixFormGroup.patchValue({
                firstCtrl: ch.pathologicalRecord,
                secondCtrl: ch.consultationMotive,
                threeCtrl: ch.anamnesis,
                fourCtrl: ch.arterialPressure,
                fifthCtrl:ch.temperature,
                sixCtrl:ch.pulse,
                sevenCtrl:ch.weight,
                eightCtrl:ch.size,
                nineCtrl:ch.breathing,
                tenCtrl:ch.head,
                elevenCtrl:ch.neck,
                twelveCtrl:ch.chest,
                thirteenCtrl:ch.belly,
                fourteenCtrl:ch.pelvis,
                fiftheenCtrl:ch.extremities,
                sixteenCtrl:ch.skin,
                seventeenCtrl:ch.centralNervousSystem,
                eighteenCtrl:ch.diagnosticImpression,
                nineteenCtrl:ch.laboratoryControl,
                twentyCtrl:ch.treatmentPlan,
                twentyOneCtrl:ch.medicDiagnostic?.diseaseCode,
                twentyTwoCtrl:ch.medicDiagnostic?.orphanDisease,
                twentyThreeCtrl:ch.medicDiagnostic?.diagnosticType,
                consultationDateEnd: ch.consultationDateEnd,
                diagnosticType: ch.diagnosticType,
                patientConditionAndDestination:ch.patientConditionAndDestination,
                patientDestinationOrganization:ch.patientDestinationOrganization,
                PatientDestinationOrganizationName:ch.patientDestinationOrganizationName


                });
      },
      error:(err)=>{

      }
     }

     )

  }

  sortBOItemxNameAscendent(list:BOItem[]): void {
    list.sort((a, b) =>
      a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );
  }

  sortBOPersonByFirstNameAscendent(list:BOPerson[]): void {
    list.sort((a, b) =>
      a.firstName.localeCompare(b.firstName, 'es', { sensitivity: 'base' })
    );
  }

  sortBOEpsByFirstNameAscendent(list:BOEps[]): void {
    list.sort((a, b) =>
      a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );
  }

  onDataUpdated(data:number):void{
  this.clinicHistoryAsignedToSell=data;
  this.clinicHistory.isPaidMethod=1;
  //this.IsPaidMethod=1;
  }

  // Método para verificar la posición del scroll y mostrar/ocultar flecha
  private checkScrollPosition()
  {
    if (this.clinicHistoryContainer?.nativeElement) {
        const element = this.clinicHistoryContainer.nativeElement;
        const scrollTop = element.scrollTop;
        const scrollHeight = element.scrollHeight;
        const clientHeight = element.clientHeight;

        // Mostrar flecha si no está cerca del final (últimos 100px)
        this.showScrollDownArrow = (scrollTop + clientHeight) < (scrollHeight - 100);
    }
  }

  // Método para hacer scroll hacia abajo a los botones
    public scrollToBottom(event?: Event) {

          if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
        if (this.clinicHistoryContainer?.nativeElement) {
            const element = this.clinicHistoryContainer.nativeElement;
            const target = element.scrollHeight - element.clientHeight;
            this.smoothScrollTo(element, target, 800);
            //element.scrollTop = target;
        }

        // También hacer scroll en modal-body si es necesario
        const modalBody = document.querySelector('.modal.show .modal-body');
        if (modalBody) {
            const target = modalBody.scrollHeight - modalBody.clientHeight;
            this.smoothScrollTo(modalBody as HTMLElement, target, 500);
          // modalBody.scrollTop = target;
        }
    }

    private scrollToTop() {
        // Scroll suave en el contenedor del modal (modal-content)
        if (this.clinicHistoryContainer?.nativeElement) {
            this.smoothScrollTo(this.clinicHistoryContainer.nativeElement, 0, 1000);
        }

        // También hacer scroll suave al modal-body
        const modalBody = document.querySelector('.modal.show .modal-body');
        if (modalBody) {
            this.smoothScrollTo(modalBody as HTMLElement, 0, 1000);
        }
    }

    // Método auxiliar para scroll suave personalizado
    private smoothScrollTo(element: HTMLElement, target: number, duration: number) {
        const start = element.scrollTop;
        const change = target - start;
        const startTime = performance.now();

        const animateScroll = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Función de easing para suavizar la animación (ease-out)
            const easeOutCubic = 1 - Math.pow(1 - progress, 3);

            element.scrollTop = start + (change * easeOutCubic);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    }

    openSellModalEmptyFromClinicHistory():void
   {
    this.isFormModalOpen = true;

    let ch= this.clinicHistory;
    let bsell:BOSell= new BOSell();
    let idTypeConverted= this.idTypeList.find(x=>x.code==ch.patient.idType).id;
    bsell.sellDetails=[];

    let nameTemp=this.getNameFromClinichistory();
    bsell.userIdString=ch.patient.personId;
   // bsell.idTypeIdentification=parseInt(ch.patient.idType),
    bsell.idTypeIdentification=idTypeConverted,

    bsell.userName=nameTemp;
    bsell.userEmail=ch.patient.email;
    bsell.dateSell=ch.consultationDate;
    bsell.clinicHistoryId=ch.id;
   // bsell.total=ch.servicePrice;
    bsell.total=0;

    bsell.areaId=ch.area;


    let bsellDetail:BOSellDetail=new BOSellDetail();
    bsellDetail.subServicesDetails=[];
    bsell.sellDetails.push(bsellDetail)
    bsell.sellDetails[0].itemSaved=false;

    this.sellModal.openSellModal(bsell,2 );

    }

    testAgrouped():void{
      this._icd10ToIcd11Service.getCei11AgroupedByIcd11("diabetes").subscribe(x=>{
      })
    }


    // obtenerDataCei10() {
    // const selectedOption = this.matSelect.selected as MatOption;
    // const dataCei10 = selectedOption._getHostElement().getAttribute('data-cei10');
    // return dataCei10;
    // }

    // getDataCei10():string
    // {
    //   let ceidata=  this.sixFormGroup.get('twentyFourCtrl')!.value;

    //   if(!ceidata)
    //   {
    //           console.log('En  getDataCei10, captura ceidata:', ceidata);
    //   }
    //   let cei10=ceidata.item.codeIcd10;
    //   return cei10;
    // }

    // getDataCei11():string{
    // let ceidata=  this.sixFormGroup.get('twentyFourCtrl')!.value;

    // let cei11=ceidata.group.key;
    // return cei11;
    // }


    compareCei11(o1: any, o2: any): boolean {
    if (!o1 || !o2) return false;
    if (!o1.group || !o2.group) return false;
    if (!o1.item || !o2.item) return false;

    const groupMatch = o1.group.key === o2.group.key;
    const itemMatch = o1.item.codeIcd10 === o2.item.codeIcd10;


    return groupMatch && itemMatch;
    }


    onClickSelectCei11Item(): void
    {
        if (this.isModalMode)
        {
            this.cei11AgroupedFilterCtrl.setValue('', { emitEvent: false });
            this.isModalMode = false;

            // Mostrar datos previos si existen
            if (this.cei11AgroupedList && this.cei11AgroupedList.length > 0) {
                this.filteredCei11Agrouped.next(this.cei11AgroupedList.slice());
            } else {
                this.filteredCei11Agrouped.next([]);
            }

        } else
        {
            if (this.cei11AgroupedList && this.cei11AgroupedList.length > 0) {
                this.filteredCei11Agrouped.next(this.cei11AgroupedList.slice());
            }
        }
    }

    private loadCei11DataIfNeeded(): void
    {
      if (this.cei11AgroupedList && this.cei11AgroupedList.length > 0) {
        this.filteredCei11Agrouped.next(this.cei11AgroupedList.slice());
        return;
      }

      // Cargar datos del servidor
      this.searchingCei11Agrouped = true;

      // ⚠️ IMPORTANTE: Usa "" en lugar de ".n" para obtener TODOS los datos
      this._icd10ToIcd11Service.getCei11AgroupedByIcd11("").subscribe(
        data => {
          this.cei11AgroupedList = data;
          this.cei11AgroupedListOriginal = data;
          this.filteredCei11Agrouped.next(data);
          this.searchingCei11Agrouped = false;
        },
        error => {
          console.error("❌ Error al cargar datos:", error);
          this.searchingCei11Agrouped = false;
        }
      );
    }


    trackByFn(index: number, item: BORelativeDisease): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }

    trackByFnPatientAllergies(index: number, item: BOPatientAllergies): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }

    trackByFnPatientFarmacologicRecord(index: number, item: BOPatientFarmacologicRecord): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }
    trackByFnPatientRiskFactor(index: number, item: BOPatientRiskFactor): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }

    trackByFnPatientDiagnosticPrincipalList(index: number, item: BODiagnosticNovo): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }

    trackByFnPatientDiagnosticRelatedList(index: number, item: BODiagnosticNovo): string {
      return item.tempId; // Angular usa esto para identificar elementos
    }
    trackByFnChControl(index: number, item: BOChControl): number {
      return item.id; // Angular usa esto para identificar elementos
    }

    handlePosSended(event: { uniqueId: string }) {

      this.relativeDiseases = this.relativeDiseases.filter(
        item => item.tempId !== event.uniqueId
      );
    }

    handlePosSendedRelativeDiseaseSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.deleteRelativeDiseaseSingle(event.itemId);
                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })
//      this.deleteRelativeDiseaseSingle(event.itemId);
    }

    handlePosSendedPatientRiskFactor(event: {uniqueId:string})
    {
      this.patientRiskFactorList = this.patientRiskFactorList.filter(
        item => item.tempId !== event.uniqueId
      );
    }

    handlePosSendedPatientRiskFactorSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                this.deletePatientRiskFactorSingle(event.itemId)

                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })
      //this.deletePatientRiskFactorSingle(event.itemId)
    }

    handlePosSendedFarmacologicRecords(event: {uniqueId:string})
    {
      this.patientFarmacologicRecordsList = this.patientFarmacologicRecordsList.filter(
        item => item.tempId !== event.uniqueId
      );
    }

    handlePosSendedPatientFarmacologicRecordSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.deletePatientFarmacologicRecordSingle(event.itemId)

                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })

      // console.log("entra al HPSPFARMACOLOGICRSINGLE");
      // this.deletePatientFarmacologicRecordSingle(event.itemId)
    }

    handlePosSendedPatientAllergies(event: { uniqueId: string })
    {

      this._ngZone.run(() => {
        this.patientAllergiesList = this.patientAllergiesList.filter(
          item => item.tempId !== event.uniqueId
        );

        this.patientAllergiesList= [... this.patientAllergiesList];
        this._cdr.detectChanges();
      })

    }

    handlePosSendedPatientAllergiesSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.deletePatientAllergiesSingle(event.itemId)

                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })
    }

    handlePosSendedChControlSingle(event: {itemId:number})
    {
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Confirma que desea borrar este item? ')
            .afterClosed().subscribe({
              next:(res)=>
              {
                confirm=res;

                if(confirm)
                {
                  this.deleteChControlSingle(event.itemId)

                }
                else
                {
                  this.close();
                }
              },
              error:(err)=>{
                console.log("Se produjo un error al confirmar borrado de paciente");
              }
            })
    }
/////

    handlePosSendedPatientPrincipal(event: {uniqueId:string})
    {

      this.deleteDiagnosticNovo()
      this.patientDiagnosticPrincipalList= this.patientDiagnosticPrincipalList.filter(
        item => item.tempId !== event.uniqueId
      );
    }

    handlePosSendedPatientPrincipalSingle(event: {itemId:number})
    {
      console.log("ENTRA A HANDLEPOSSENDEDPATIENTPRINCIPAL-SINGLE");
      this.deleteDiagnostiPrincipalSingle(event.itemId);
    }


    handlePosSendedPatientRelated(event: {uniqueId:string})
    {
      this.patientDiagnosticRelatedList = this.patientDiagnosticRelatedList.filter(
        item => item.tempId !== event.uniqueId
      );
    }


    handlePosSendedPatientRelatedSingle(event: {itemId:number})
    {
      this.deleteDiagnosticRelatedSingle(event.itemId);
    }




    generarateGUI(): string {
      return `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    }
///RELATIVEDISEASE
    saveRelativeDiseases()
    {
      const transp= new BOTranspRelativeDisease();
      transp.patientId=this.clinicHistory.patient.id;
      transp.relativeDiseases=this.relativeDiseases;

      this._relativeDiseaseService.createOrUpdateRelativeDiseases(transp).subscribe({
        next:(data)=>{
          if(data)
          {
              // if(data.length>0) this.btnSaveRelativeDisease = true;

              // setTimeout(() => {
              //   this.btnSaveRelativeDisease==true? this.btnSaveRelativeDisease=false: this.btnSaveRelativeDisease=true;
              // }, 3000);
              this.toastr.success("Éxito", "Se guardaron los datos");          }
          else
          {
            this.toastr.error("Fallo", "No se guardaron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar Enfermedades de Familiares");
        }
      })

    }
    saveRelativeDiseaseSingle(item: BORelativeDisease)
    {
      this._relativeDiseaseService.createOrUpdateRelativeDiseaseSingle(this.clinicHistory.patient.id,  item).subscribe({
        next:(data)=>{
          if(data)
          {
            data.tempId=this.generarateGUI();
            this.relativeDiseases.push(data);
            console.log("En SAVERELATIVEDISEASE data es:", data);
            this.toastr.success("Éxito", "Se guardó el dato");

          }
          else
          {
            this.toastr.error("Fallo", "No se guardó el dato");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar datos");
        }
      })
          //this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;
    }
    deleteRelativeDiseaseSingle(itemId:number)
    {
      console.log("ENTRA A DELETERELATIVEDISEASESINGLE")
      this._relativeDiseaseService.deleteRelativeDiseaseSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {

            const pos =this.relativeDiseases.findIndex(x=>x.id===itemId);
            if(pos !==-1)this.relativeDiseases.splice(pos, 1);
            this.toastr.success("Éxito", "Se borraron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
        //  this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;

    }
    createNewDiseaseRelative()
    {
      const nRD= new BORelativeDisease();
          nRD.tempId= this.generarateGUI();
          nRD.patientId=this.patient.id;
          nRD.cei10Code=this.code10;
          nRD.cei10Name=this.code10Title;
          nRD.cei11Code=this.code11;
          nRD.cei11Name=this.code11Title;
          nRD.relativeType= this.relativeDiseaseFormGroup.get('relativeType').value;
          this.relativeDiseases.push(nRD);

          // Actualizar formulario
          this.relativeDiseaseFormGroup.patchValue({
              cei11Diagnostic: null,
              relativeType:null
          })
    }

    createNewDiseaseRelativeSingle()
    {
      const nRD= new BORelativeDisease();
          nRD.tempId= this.generarateGUI();
          nRD.patientId=this.patient.id;
          nRD.cei10Code=this.code10;
          nRD.cei10Name=this.code10Title;
          nRD.cei11Code=this.code11;
          nRD.cei11Name=this.code11Title;
          nRD.relativeType= this.relativeDiseaseFormGroup.get('relativeType').value;
         // this.relativeDiseases.push(nRD);

          this.saveRelativeDiseaseSingle(nRD);

          // Actualizar formulario
          this.relativeDiseaseFormGroup.patchValue({
              cei11Diagnostic: null,
              relativeType:null
          })
    }

/// PATIENTRISKFACTOR

    savePatientRiskFactor(): void {

        const transp = new BOTransPatientRiskFactor();
        transp.patientId =this.clinicHistory.patient.id;
        transp.patientRiskFactors = this.patientRiskFactorList;

        this._patientRiskFactorService.createOrUpdatePatientRiskFactor(transp).subscribe({

                next: (data) =>
                {

                  data.forEach(x=>{
                    x.tempId=this.generarateGUI();
                  })

                  console.log("EN SAVEPATIENTRISKFACTOR, data es:", data);

                    this.patientRiskFactorList = [...  data];
         //           data.length>0?this.btnsavePatientRiskFactor = false:this.btnsavePatientRiskFactor = true;
          if(data.length>0) this.btnsavePatientRiskFactor = true;

          setTimeout(() => {
            this.btnsavePatientRiskFactor==true? this.btnsavePatientRiskFactor=false: this.btnsavePatientRiskFactor=true;
          }, 3000);
          this.toastr.success("Éxito", "Se guardaron los datos");

                    this.toastr.success(
                        "Éxito",
                        "Se guardaron los datos"
                    );
                },

                error: (err) => {

                    console.error(err);

                    this.toastr.error(
                        "Fallo",
                        "No se pudieron guardar los datos"
                    );
                }
            });
       //   this.btnsavePatientRiskFactor==true? this.btnsavePatientRiskFactor=false: this.btnsavePatientRiskFactor=true;

    }

    savePatientRiskFactorSingle(item: BOPatientRiskFactor): void
    {

    this._patientRiskFactorService.createOrUpdatePatientRiskFactorSingle(this.clinicHistory.patient.id,  item).subscribe({

        next:(data)=>{
              if(data)
              {
                data.tempId=this.generarateGUI();
                this.patientRiskFactorList.push(data);
                console.log("En SAVEPATIENTRISKFACTOR data es:", data);
                this.toastr.success("Éxito", "Se guardó el dato");

              }
              else
              {
                this.toastr.error("Fallo", "No se guardó el dato");
              }
            },
            error:(err)=>{
              console.log("Se produjo en error en guardar o actualizar datos");
            }
          })

    }

    deletePatientRiskFactorSingle(itemId:number)
    {
      console.log("ENTRA A DELETEPATIENTRISKFACTORSINGLE")
      this._patientRiskFactorService.deletePatientRiskFactorSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {

            const pos =this.patientRiskFactorList.findIndex(x=>x.id===itemId);
            if(pos !==-1)this.patientRiskFactorList.splice(pos, 1);
            this.toastr.success("Éxito", "Se borraron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
    }

    createNewPatientRiskFactor()
    {
      let code=this.detailPatientRiskFactorFormGroup.get('riskFactorType').value;
      let detail=this.detailPatientRiskFactorFormGroup.get('riskFactorDetail').value;

      console.log("En CNPATIENTRISKFACTOR, detail es:", detail);

      const [codeTemp, nameTemp] = code.split("@");

      const nr=new BOPatientRiskFactor();
      nr.tempId=this.generarateGUI();
      nr.patientId=this.patient.id;
      nr.riskFactorType=codeTemp;
      nr.riskFactorName=nameTemp;
      nr.riskFactorDetail=detail;

      this.patientRiskFactorList.push(nr);

      this.detailPatientRiskFactorFormGroup.patchValue({
        riskFactorType: null,
        riskFactorDetail:null
      })

    }

    createNewPatientRiskFactorSingle()
    {
      let code=this.detailPatientRiskFactorFormGroup.get('riskFactorType').value;
      let detail=this.detailPatientRiskFactorFormGroup.get('riskFactorDetail').value;

      console.log("En CNPATIENTRISKFACTOR, detail es:", detail);

      const [codeTemp, nameTemp] = code.split("@");

      const nr=new BOPatientRiskFactor();
      nr.tempId=this.generarateGUI();
      nr.patientId=this.patient.id;
      nr.riskFactorType=codeTemp;
      nr.riskFactorName=nameTemp;
      nr.riskFactorDetail=detail;

     // this.patientRiskFactorList.push(nr);
      this.savePatientRiskFactorSingle(nr);

      this.detailPatientRiskFactorFormGroup.patchValue({
        riskFactorType: null,
        riskFactorDetail:null
      })

    }

/// FARMACOLOGICRECORDS
    saveFarmacologicRecords()
    {
      const transp= new BOTranspFarmacologicRecords();
      transp.patientId=this.clinicHistory.patient.id;
      transp.PatientFarmacologicRecords=this.patientFarmacologicRecordsList;

      this._patientFarmacologicRecordService.createOrUpdatePatientFarmacologicRecords(transp).subscribe({
        next:(data)=>
        {

          data.forEach(x=>{
            x.tempId=this.generarateGUI();
          })

          this.patientFarmacologicRecordsList=data;
         // data.length>0?this.btnSaveFarmacologicRecords=false:this.btnSaveFarmacologicRecords=true;
          if(data.length>0) this.btnSaveFarmacologicRecords = true;

          setTimeout(() => {
            this.btnSaveFarmacologicRecords==true? this.btnSaveFarmacologicRecords=false: this.btnSaveFarmacologicRecords=true;
          }, 3000);
          this.toastr.success("Éxito", "Se guardaron los datos");

        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar Enfermedades de Familiares");
        }
      })
         // data.length>0? this.btnSaveFarmacologicRecords==false:this.btnSaveFarmacologicRecords=true;
          this.btnSaveFarmacologicRecords==true? this.btnSaveFarmacologicRecords=false: this.btnSaveFarmacologicRecords=true;


    }

    saveFarmacologicRecordSingle(item: BOPatientFarmacologicRecord)
    {

      this._patientFarmacologicRecordService.createOrUpdatePatientFarmacologicRecordSingle(this.clinicHistory.patient.id,  item).subscribe({
        next:(data)=>
        {
          if(data)
          {
            data.tempId=this.generarateGUI();
            this.patientFarmacologicRecordsList.push(data);
            console.log("En SAVEFARMACOLOGICRECORD data es:", data);
            this.toastr.success("Éxito", "Se guardó el dato");

          }
          else
          {
            this.toastr.error("Fallo", "No se guardó el dato");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar datos");
        }
      })

    }

    deletePatientFarmacologicRecordSingle(itemId:number)
    {
      console.log("ENTRA A DELETEPATIENTFARMACOLOGRECORDSINGLE")
      this._patientFarmacologicRecordService.deletePatientFarmacologicRecordSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {

            const pos =this.patientFarmacologicRecordsList.findIndex(x=>x.id===itemId);
            if(pos !==-1)this.patientFarmacologicRecordsList.splice(pos, 1);
            this.toastr.success("Éxito", "Se borraron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
    }

    createNewPatientFarmacologicRecord()
    {
      let code=this.medicinesFormGroup.get('code').value;
      const [codeTemp, nameTemp, enabledTemp] = code.split("@");
      let enabledFinal=false;
      enabledTemp==='true'? enabledFinal=true:enabledFinal=false;

      const nr=new BOPatientFarmacologicRecord();
      nr.tempId=this.generarateGUI();
      nr.patientId=this.patient.id;
      nr.code=codeTemp;
      nr.name=nameTemp;
      nr.enabled=enabledFinal;

      this.patientFarmacologicRecordsList.push(nr);

      this.medicinesFormGroup.patchValue({
        code: null,
        value:null

      })


    }

    createNewPatientFarmacologicRecordSingle()
    {
      let code=this.medicinesFormGroup.get('code').value;
      const [codeTemp, nameTemp, enabledTemp] = code.split("@");
      let enabledFinal=false;
      enabledTemp==='true'? enabledFinal=true:enabledFinal=false;

      const nr=new BOPatientFarmacologicRecord();
      nr.tempId=this.generarateGUI();
      nr.patientId=this.patient.id;
      nr.code=codeTemp;
      nr.name=nameTemp;
      nr.enabled=enabledFinal;

     // this.patientFarmacologicRecordsList.push(nr);
      this.saveFarmacologicRecordSingle(nr);

      this.medicinesFormGroup.patchValue({
        code: null,
        value:null
      })

    }
///PATIENT ALLERGIS

    savePatientAllergies()
    {
      const transp= new BOTranspPatientAllergies();
      transp.patientId=this.clinicHistory.patient.id;
      transp.PatientAllergies=this.patientAllergiesList;

      this._patientAllergiesService.createOrUpdatePatientAllergies(transp).subscribe({
        next:(data)=>
        {
          data.forEach(x=>{
            x.tempId=this.generarateGUI();
          });

          this.patientAllergiesList = [...  data];

//          data.length>0?this.btnSavePatientAllergies = false:this.btnSavePatientAllergies = true;
          if(data.length>0) this.btnSavePatientAllergies = true;

          setTimeout(() => {
            this.btnSavePatientAllergies==true? this.btnSavePatientAllergies=false: this.btnSavePatientAllergies=true;
          }, 3000);
          this.toastr.success("Éxito", "Se guardaron los datos");

        },
        error:(err)=>
        {
          this.toastr.error("Fallo", "No se pudieron guardar los datos" );
        }
      })


    }
    savePatientAllergiesSingle(item: BOPatientAllergies)
    {
      this._patientAllergiesService.createOrUpdatePatientAllergiesSingle(this.clinicHistory.patient.id,  item).subscribe({
        next:(data)=>
        {
          if(data)
          {
            data.tempId=this.generarateGUI();
            this.patientAllergiesList.push(data);
            //console.log("En SAVEFARMACOLOGICRECORD data es:", data);
            this.toastr.success("Éxito", "Se guardó el dato");

          }
          else
          {
            this.toastr.error("Fallo", "No se guardó el dato");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar datos");
        }
      })


    }

    deletePatientAllergiesSingle(itemId:number)
    {
//console.log("ENTRA A DELETEPATIENTFARMACOLOGRECORDSINGLE")
      this._patientAllergiesService.deletePatientAllergiesSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {

            const pos =this.patientAllergiesList.findIndex(x=>x.id===itemId);
            if(pos !==-1)this.patientAllergiesList.splice(pos, 1);
            this.toastr.success("Éxito", "Se borraron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de alergias");
        }
      })
    }


    createPatientAllergies()
    {
      const allergyType=this.patientAllergiesFormGroup.get('allergyType').value;
      const allergen=this.patientAllergiesFormGroup.get('allergen').value;
      const allergyName= Utilities.getAllergyTypeName(allergyType, this.medicAllergyTypeList);

    const nPA= new BOPatientAllergies();
    nPA.tempId=this.generarateGUI();
    nPA.patientId=this.patient.id;
    nPA.allergyType= allergyType;
    nPA.allergyName=allergyName;
    nPA.allergen=allergen;

    this.patientAllergiesFormGroup.patchValue({
      allergyType: null,
      allergen: null
    })

      this._ngZone.run(() => {
     this.patientAllergiesList= [...this.patientAllergiesList, {...nPA} ];


      });
     //this.patientAllergiesList= [...this.patientAllergiesList, {...nPA} ];


    }

    createPatientAllergiesSingle()
    {
      const allergyType=this.patientAllergiesFormGroup.get('allergyType').value;
      const allergen=this.patientAllergiesFormGroup.get('allergen').value;
      const allergyName= Utilities.getAllergyTypeName(allergyType, this.medicAllergyTypeList);

    const nPA= new BOPatientAllergies();
    nPA.tempId=this.generarateGUI();
    nPA.patientId=this.patient.id;
    nPA.allergyType= allergyType;
    nPA.allergyName=allergyName;
    nPA.allergen=allergen;

    this.patientAllergiesFormGroup.patchValue({
      allergyType: null,
      allergen: null
    })

  this.savePatientAllergiesSingle(nPA);
    //   this._ngZone.run(() => {
    //  this.patientAllergiesList= [...this.patientAllergiesList, {...nPA} ];


    //   });
     //this.patientAllergiesList= [...this.patientAllergiesList, {...nPA} ];


    }

//CLINICHISTORY CONTROLS
saveChControlSingle(item: BOChControl)
{
  this._chControlService.createOrUpdateChControlSingle(
    this.clinicHistory.id,
    item
  ).subscribe({
    next: (result) => {
      // Resultado exitoso
      this.chControlList.push(result);
      // console.log("Control guardado con número:", result.controlNumber);
      // console.log("Datos del control:", result);
      this.isChDiagnosticPanelOpen=false;
      this.toastr.success("Éxito", "Se guardó el control y se incrementó la consulta");
    },
    error: (err) => {
      console.error("Error en la operación:", err);
      this.toastr.error("Error", "No se pudo completar la operación. Por favor, intente nuevamente.");
    }
  });
}

createNewChControlSingle()
{
  const controlDate=this.chControlFatherFormGroup.get('controlDate').value;
  const professionalId=this.chControlFatherFormGroup.get('professionalId').value;
  const details= this.chControlFatherFormGroup.get('details').value;
  const ch= this.clinicHistory;
  //const ctrlN=ch.controlConsultation==0?1:ch.controlConsultation+1;
  const ctrlN=ch.controlConsultation+1;
  console.log("EN CNCSINGLE  professionalId es: ", professionalId, " y su tipo es: ", typeof professionalId);



const ncc= new BOChControl();
ncc.clinicHistoryId=this.clinicHistory.id;
ncc.patientId=this.patient.id;
ncc.controlNumber=ctrlN;
//ncc.professionalId= this.clinicHistory.profesionalId;
ncc.professionalId= typeof professionalId === 'string' ? parseInt(professionalId) : professionalId;


ncc.controlDate = controlDate ? new Date(controlDate) : null;   // ncc.controlDate=controlDate;

ncc.details=details;

this.chControlFatherFormGroup.patchValue({
  controlDate: null,
  professionalId: null,
  details:null
})

this.saveChControlSingle(ncc);


}

deleteChControlSingle(itemId:number)
{
//console.log("ENTRA A DELETEPATIENTFARMACOLOGRECORDSINGLE")
  this._chControlService.deleteChControlSingle(itemId).subscribe({
    next:(data)=>{
      if(data)
      {

        const pos =this.chControlList.findIndex(x=>x.id===itemId);
        if(pos !==-1)this.chControlList.splice(pos, 1);
        this.toastr.success("Éxito", "Se borraron los datos");
      }
      else
      {
        this.toastr.error("Fallo", "No se borraron los datos");
      }
    },
    error:(err)=>{
      console.log("Se produjo en error al eliminar registros de alergias");
    }
  })
}


// DIAGNOSTICS
    saveDiagnosticPrincipal()
    {
      const transp= new BOTranspDiagnosticNovo();
      transp.patientId=this.clinicHistory.patient.id;
      transp.clinicHistoryId= this.clinicHistory.id;
      transp.diagnosticNovos=this.patientDiagnosticPrincipalList;

      this._patientDiagnosticService.createOrUpdateDiagnosticNovo(transp).subscribe({
        next:(data)=>{
          if(data)
          {
            this.patientDiagnosticPrincipalList=[];
            this.patientDiagnosticPrincipalList=data;
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.toastr.success("Éxito", "Se guardaron los datos");
            this.showDiagnosticPrincipal_ppal=false;
            this.showDiagnosticPrincipal_orpha=false;




          }
          else
          {
            this.toastr.error("Fallo", "No se guardaron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar Enfermedades de Familiares");
        }
      })
          //this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;
    }

    saveDiagnosticRelated()
    {
      const patientDiagnosticConsolidated= [...this.patientDiagnosticPrincipalList, ...this.patientDiagnosticRelatedList];

      const transp= new BOTranspDiagnosticNovo();
      transp.patientId=this.clinicHistory.patient.id;
      transp.clinicHistoryId= this.clinicHistory.id;
      //transp.diagnosticNovos=this.patientDiagnosticRelatedList;
      transp.diagnosticNovos=patientDiagnosticConsolidated;


      this._patientDiagnosticService.createOrUpdateDiagnosticNovo(transp).subscribe({
        next:(data)=>{
          if(data)
          {
            this.patientDiagnosticRelatedList=[];
            this.patientDiagnosticRelatedList=data;
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.showDiagnosticRelated_ppal=false;
            this.showDiagnosticRelated_orpha=false;

            if(data.length>0) this.btnSaveDiagnosticRelated=true;

          setTimeout(() => {
            this.btnSaveDiagnosticRelated==true? this.btnSaveDiagnosticRelated=false: this.btnSaveDiagnosticRelated=true;
          }, 3000);
          this.toastr.success("Éxito", "Se guardaron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se guardaron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar Enfermedades de Familiares");
        }
      })
          //this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;
    }


    deleteDiagnosticNovo()
    {
      const transp= new BOTranspDiagnosticNovo();
      transp.patientId=this.clinicHistory.patient.id;
      transp.clinicHistoryId= this.clinicHistory.id;
      transp.diagnosticNovos=this.patientDiagnosticPrincipalList;

      this._patientDiagnosticService.deleteDiagnosticNovo(transp).subscribe({
        next:(data)=>{
          if(data)
          {
           // this.patientDiagnosticPrincipalList=data;
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.toastr.success("Éxito", "Se borraron los datos");
            this.showDiagnosticPrincipal_ppal=false;
            this.showDiagnosticPrincipal_orpha=false;
            this.showDiagnosticPrincipal_ppal_diseaseType=true;
            //this.sdrpd.next(true);

          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
        //  this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;

    }

    deleteDiagnosticNovoRelated()
    {
      const transp= new BOTranspDiagnosticNovo();
      transp.patientId=this.clinicHistory.patient.id;
      transp.clinicHistoryId= this.clinicHistory.id;
      transp.diagnosticNovos=this.patientDiagnosticRelatedList;

      this._patientDiagnosticService.deleteDiagnosticNovo(transp).subscribe({
        next:(data)=>{
          if(data)
          {
           // this.patientDiagnosticPrincipalList=data;
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.toastr.success("Éxito", "Se borraron los datos");
            this.showDiagnosticRelated_ppal=false;
            this.showDiagnosticRelated_orpha=false;
           // this.showDiagnosticRelated_ppal_diseaseType=true;
            this.sdrpd.next(true);

          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
        //  this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;

    }

   saveDiagnosticRelatedSingle(item: BODiagnosticNovo)
  {

      this._patientDiagnosticService.createOrUpdateDiagnosticSingle
      (this.clinicHistory.patient.id, this.clinicHistory.id, item).subscribe({
        next:(data)=>{
          if(data)
          {
            data.tempId=this.generarateGUI();
           // this.patientDiagnosticRelatedList=[];
            this.patientDiagnosticRelatedList.push(data);
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.showDiagnosticRelated_ppal=false;
            this.showDiagnosticRelated_orpha=false;

            this.btnSaveDiagnosticRelated=true;

          setTimeout(() => {
            this.btnSaveDiagnosticRelated==true? this.btnSaveDiagnosticRelated=false: this.btnSaveDiagnosticRelated=true;
          }, 3000);
          this.toastr.success("Éxito", "Se guardaron los datos");
          }
          else
          {
            this.toastr.error("Fallo", "No se guardaron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar Enfermedades de Familiares");
        }
      })
          //this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;
    }

    saveDiagnosticPrincipalSingle(item: BODiagnosticNovo)
    {
      this._patientDiagnosticService.createOrUpdateDiagnosticSingle(this.clinicHistory.patient.id, this.clinicHistory.id, item).subscribe({
        next:(data)=>{
          if(data)
          {
            data.tempId=this.generarateGUI();
            this.patientDiagnosticPrincipalList=[];
            this.patientDiagnosticPrincipalList.push(data);
            console.log("En SAVEDIAGNOSTICPRINCIPAL, data es:", data);
            this.toastr.success("Éxito", "Se guardó el dato");
            this.showDiagnosticPrincipal_ppal=false;
            this.showDiagnosticPrincipal_orpha=false;
          }
          else
          {
            this.toastr.error("Fallo", "No se guardó el dato");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error en guardar o actualizar datos");
        }
      })
          //this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;
    }

    deleteDiagnostiPrincipalSingle(itemId:number)
    {
      this._patientDiagnosticService.deleteDiagnosticSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {
           // this.patientDiagnosticPrincipalList=data;
            this.patientDiagnosticPrincipalList=[];
            this.toastr.success("Éxito", "Se borraron los datos");
            this.showDiagnosticPrincipal_ppal=false;
            this.showDiagnosticPrincipal_orpha=false;
            this.showDiagnosticPrincipal_ppal_diseaseType=true;
            //this.sdrpd.next(true);

          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
        //  this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;

    }
    deleteDiagnosticRelatedSingle(itemId:number)
    {
      this._patientDiagnosticService.deleteDiagnosticSingle(itemId).subscribe({
        next:(data)=>{
          if(data)
          {
            const pos =this.patientDiagnosticRelatedList.findIndex(x=>x.id===itemId);
            if(pos !==-1)this.patientDiagnosticRelatedList.splice(pos, 1);

           this.toastr.success("Éxito", "Se borraron los datos");
            this.showDiagnosticPrincipal_ppal=false;
            this.showDiagnosticPrincipal_orpha=false;
            this.showDiagnosticPrincipal_ppal_diseaseType=true;
            //this.sdrpd.next(true);

          }
          else
          {
            this.toastr.error("Fallo", "No se borraron los datos");
          }
        },
        error:(err)=>{
          console.log("Se produjo en error al eliminar registros de  Enfermedades de Familiares");
        }
      })
        //  this.btnSaveDiagnosticPrincipal==true? this.btnSaveDiagnosticPrincipal=false: this.btnSaveDiagnosticPrincipal=true;

    }


    createNewPatientDiagnosticPrincipal()
    {
      const details= this.patientDiagnosticPrincipalFormGroup.get('details').value;
      const code= this.patientDiagnosticPrincipalFormGroup.get('diseaseName').value;
      const diagnosticType= this.patientDiagnosticPrincipalFormGroup.get('diagnosticType').value;
      console.log("EN CREATENEWPATIENTDIAGNOSTICPRICIPAL, diagnosticType es:", diagnosticType);
      const diseaseType=this.showDiagnosticPrincipal_ppal?1:2;

      const nd=new BODiagnosticNovo();
      nd.tempId=this.generarateGUI();
      nd.patientId=this.patient.id;
      nd.clinicHistoryId=this.clinicHistory.id;
      nd.cie10Code= this.selectedCodeIcd10?? "";
      nd.cie10Name=this.selectedTitleIcd10?? "";
      nd.cie11Code=this.selectedGroupCodeIcd11?? "";
      nd.cie11Name=this.selectedTitleIcd11?? "";
      nd.diseaseType=diseaseType;
      nd.diagnosticCategory=1;
      nd.diagnosticType=diagnosticType;
      nd.patientId=this.patient.id;
      nd.details=details;



      if(diseaseType==2)
      {
        let [codeTemp, nameTemp] = code.split("@");
        nd.orphanDiseaseCode=codeTemp??"";
        nd.orphanDiseaseName=nameTemp??"";
      }
      else
      {
        nd.orphanDiseaseCode="";
        nd.orphanDiseaseName="";
      }

      //this.patientDiagnosticPrincipalList.push(nd);
      console.log("En CNPDP, nd es:", nd);

      //this.saveDiagnosticPrincipal();

       this.saveDiagnosticPrincipalSingle(nd);

      this.patientDiagnosticPrincipalFormGroup.patchValue({
        diseaseCode:"",
        diseaseName:"",
        details:"",
      })
      this.cleanDiagnosticPrincipal();

      this.showDiagnosticPrincipal_ppal=false;
      this.showDiagnosticPrincipal_orpha=false;
      this.showDiagnosticPrincipal_ppal_diseaseType=false;
     // this.sdrpd.next(false);
    }

    createNewPatientDiagnosticRelated()
    {
      const details= this.patientDiagnosticRelatedFormGroup.get('details').value;
      const code= this.patientDiagnosticRelatedFormGroup.get('diseaseName').value;
      const diagnosticType= this.patientDiagnosticRelatedFormGroup.get('diagnosticType').value;
      console.log("EN CREATENEWPATIENTDIAGNOSTICRELATED, diagnosticType es:", diagnosticType);
      const diseaseType=this.showDiagnosticRelated_ppal?1:2;

      const nd=new BODiagnosticNovo();
      nd.tempId=this.generarateGUI();
      nd.patientId=this.patient.id;
      nd.clinicHistoryId=this.clinicHistory.id;

      nd.diseaseType=diseaseType;
      nd.diagnosticCategory=2;
      nd.diagnosticType=diagnosticType;
      nd.patientId=this.patient.id;
      nd.details=details;



      if(diseaseType==2)
      {
        let [codeTemp, nameTemp] = code.split("@");
        nd.orphanDiseaseCode=codeTemp??"";
        nd.orphanDiseaseName=nameTemp??"";
      }
      else
      {

        nd.cie10Code= this.selectedCodeIcd10?? "";
        nd.cie10Name=this.selectedTitleIcd10?? "";
        nd.cie11Code=this.selectedGroupCodeIcd11?? "";
        nd.cie11Name=this.selectedTitleIcd11?? "";
        nd.orphanDiseaseCode="";
        nd.orphanDiseaseName="";
      }

       this.saveDiagnosticRelatedSingle(nd);


      this.patientDiagnosticRelatedFormGroup.patchValue({
        diseaseCode:"",
        diseaseName:"",
        details:"",
      })

      this.showDiagnosticRelated_ppal=false;
      this.showDiagnosticRelated_orpha=false;

     // this.showDiagnosticPrincipal_ppal_diseaseType=false;
      this.sdrpd.next(false);


    }

    cleanDiagnosticPrincipal()
    {
      this.selectedCodeIcd10= "";
      this.selectedTitleIcd10= "";
      this.selectedGroupCodeIcd11= "";
      this.selectedTitleIcd11= "";
    }

    showPatientWithTypeDocumentActive(docuType: string)
    {
              this._dialogAlertService.openAlertDialog("El paciente ya existe con otro tipo de documento:", docuType,".Debe editar el tipo documento en Paciente");
              this.close();

    }

    showDiagnosticPrincipal(diag: string)
    {

    }

    getNameProfessional(id:number):string
    {
      const name=Utilities.getProfesionalName(id,this.profesionalsListShort);
      return name;
    }

        handleCallPatientName():string
    {
      const name=Utilities.getNameFromPerson(this.clinicHistory.patient);
      return name;
    }

    getStringFromDate(dateT:Date):string
    {
      const result=Utilities.convertDateToString(dateT);
      return result;
    }

  dateNow()
  {
    let nowD= new Date();
    this.destinationPatientFormGroup.patchValue({
      consultationDateEnd: new Date()
    })

    this._cdr.detectChanges();

  }




}
